function PlanMM({ ...props }) {
	return (
		<g {...props} id="unit-mm">
			<g id="furniture">
				<polyline
					points="360.88 370.22 360.88 371.7 357.95 371.7 357.95 370.22 360.88 370.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="407.78 373.18 407.78 562.59 364.39 562.59 364.39 373.18 407.78 373.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="539.41"
					y1="535.57"
					x2="539.41"
					y2="513.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.85"
					y1="535.57"
					x2="539.41"
					y2="535.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.41"
					y1="513.36"
					x2="536.78"
					y2="513.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.65"
					y1="513.36"
					x2="531.09"
					y2="513.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.96"
					y1="513.36"
					x2="525.41"
					y2="513.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.28"
					y1="513.36"
					x2="519.72"
					y2="513.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.59"
					y1="513.36"
					x2="514.04"
					y2="513.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.91"
					y1="513.36"
					x2="508.35"
					y2="513.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.22"
					y1="513.36"
					x2="502.67"
					y2="513.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.85"
					y1="524.79"
					x2="480.85"
					y2="528.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.85"
					y1="530.48"
					x2="480.85"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.85"
					y1="534.09"
					x2="483.48"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.61"
					y1="534.09"
					x2="489.17"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.3"
					y1="534.09"
					x2="494.85"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.98"
					y1="534.09"
					x2="500.54"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.67"
					y1="534.09"
					x2="506.22"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.35"
					y1="534.09"
					x2="511.91"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.04"
					y1="534.09"
					x2="517.59"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.72"
					y1="534.09"
					x2="523.28"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.41"
					y1="534.09"
					x2="528.96"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.09"
					y1="534.09"
					x2="534.65"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.78"
					y1="534.09"
					x2="539.41"
					y2="534.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.41"
					y1="534.09"
					x2="539.41"
					y2="530.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.41"
					y1="528.34"
					x2="539.41"
					y2="524.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.41"
					y1="522.66"
					x2="539.41"
					y2="519.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.41"
					y1="516.97"
					x2="539.41"
					y2="513.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.84"
					y1="372.52"
					x2="419.63"
					y2="372.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.84"
					y1="505.96"
					x2="441.84"
					y2="372.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="372.52"
					x2="419.63"
					y2="375.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="389.14"
					x2="419.63"
					y2="392.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="394.83"
					x2="419.63"
					y2="398.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="400.51"
					x2="419.63"
					y2="404.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="406.2"
					x2="419.63"
					y2="409.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="411.88"
					x2="419.63"
					y2="415.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="417.57"
					x2="419.63"
					y2="421.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="423.25"
					x2="419.63"
					y2="426.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="434.62"
					x2="419.63"
					y2="438.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="440.31"
					x2="419.63"
					y2="443.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="445.99"
					x2="419.63"
					y2="449.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="451.68"
					x2="419.63"
					y2="455.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="457.36"
					x2="419.63"
					y2="460.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="463.05"
					x2="419.63"
					y2="466.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="468.73"
					x2="419.63"
					y2="472.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="474.42"
					x2="419.63"
					y2="477.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="480.1"
					x2="419.63"
					y2="483.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.63"
					y1="485.79"
					x2="419.63"
					y2="489.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.06"
					y1="505.96"
					x2="434.62"
					y2="505.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.75"
					y1="505.96"
					x2="440.36"
					y2="505.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="505.96"
					x2="440.36"
					y2="502.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="500.71"
					x2="440.36"
					y2="497.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="495.03"
					x2="440.36"
					y2="491.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="489.34"
					x2="440.36"
					y2="485.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="483.66"
					x2="440.36"
					y2="480.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="477.97"
					x2="440.36"
					y2="474.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="472.29"
					x2="440.36"
					y2="468.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="466.6"
					x2="440.36"
					y2="463.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="460.92"
					x2="440.36"
					y2="457.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="455.23"
					x2="440.36"
					y2="451.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="449.55"
					x2="440.36"
					y2="445.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="443.86"
					x2="440.36"
					y2="440.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="438.18"
					x2="440.36"
					y2="434.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="432.49"
					x2="440.36"
					y2="428.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="426.81"
					x2="440.36"
					y2="423.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="421.12"
					x2="440.36"
					y2="417.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="415.44"
					x2="440.36"
					y2="411.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="409.75"
					x2="440.36"
					y2="406.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="404.06"
					x2="440.36"
					y2="400.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="398.38"
					x2="440.36"
					y2="394.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="392.69"
					x2="440.36"
					y2="389.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="387.01"
					x2="440.36"
					y2="383.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="381.32"
					x2="440.36"
					y2="377.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="375.64"
					x2="440.36"
					y2="372.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.36"
					y1="372.52"
					x2="436.75"
					y2="372.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.62"
					y1="372.52"
					x2="431.06"
					y2="372.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.93"
					y1="372.52"
					x2="425.38"
					y2="372.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.25"
					y1="372.52"
					x2="419.63"
					y2="372.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.96"
					y1="545.16"
					x2="735.96"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="485.78"
					x2="713.76"
					y2="489.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="491.47"
					x2="713.76"
					y2="495.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="497.15"
					x2="713.76"
					y2="500.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.19"
					y1="545.16"
					x2="728.74"
					y2="545.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.87"
					y1="545.16"
					x2="734.48"
					y2="545.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="545.16"
					x2="734.48"
					y2="542.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="540.5"
					x2="734.48"
					y2="536.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="534.82"
					x2="734.48"
					y2="531.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="529.13"
					x2="734.48"
					y2="525.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="523.44"
					x2="734.48"
					y2="519.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="517.76"
					x2="734.48"
					y2="514.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="512.07"
					x2="734.48"
					y2="508.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="506.39"
					x2="734.48"
					y2="502.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="500.7"
					x2="734.48"
					y2="497.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="495.02"
					x2="734.48"
					y2="491.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="489.33"
					x2="734.48"
					y2="485.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="483.65"
					x2="734.48"
					y2="480.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="477.96"
					x2="734.48"
					y2="474.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="472.28"
					x2="734.48"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.48"
					y1="469.76"
					x2="730.87"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.74"
					y1="469.76"
					x2="725.19"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="430.61 555.79 430.61 515.82 470.58 515.82 470.58 555.79 430.61 555.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="50 686.76 50 683.8 50 406.96 50.52 398.39 52.06 389.95 54.62 381.76 58.14 373.93 62.58 366.59 67.87 359.83 73.94 353.77 80.69 348.47 88.04 344.03 95.86 340.51 104.06 337.96 112.5 336.41 121.06 335.89 176.2 335.89 172.97 338.85 121.06 338.85 112.85 339.35 104.77 340.83 96.91 343.28 89.41 346.66 82.38 350.91 75.9 355.98 70.09 361.8 65.02 368.27 60.76 375.31 57.39 382.81 54.94 390.66 53.46 398.75 52.96 406.96 52.96 683.8 144.87 683.8 144.87 686.76 50 686.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="50"
					y1="686.76"
					x2="144.87"
					y2="686.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="686.76"
					x2="144.87"
					y2="683.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="683.8"
					x2="52.96"
					y2="683.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.96"
					y1="683.8"
					x2="52.96"
					y2="406.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.96"
					y1="406.96"
					x2="53.46"
					y2="398.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="53.46"
					y1="398.75"
					x2="54.94"
					y2="390.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="54.94"
					y1="390.66"
					x2="57.39"
					y2="382.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="57.39"
					y1="382.81"
					x2="60.76"
					y2="375.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="60.76"
					y1="375.31"
					x2="65.02"
					y2="368.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.02"
					y1="368.27"
					x2="70.09"
					y2="361.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="70.09"
					y1="361.8"
					x2="75.9"
					y2="355.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="75.9"
					y1="355.98"
					x2="82.38"
					y2="350.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="82.38"
					y1="350.91"
					x2="89.41"
					y2="346.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.41"
					y1="346.66"
					x2="96.91"
					y2="343.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.91"
					y1="343.28"
					x2="104.77"
					y2="340.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.77"
					y1="340.83"
					x2="112.85"
					y2="339.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.85"
					y1="339.35"
					x2="121.06"
					y2="338.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.06"
					y1="338.85"
					x2="172.97"
					y2="338.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.97"
					y1="338.85"
					x2="176.2"
					y2="335.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.2"
					y1="335.89"
					x2="121.06"
					y2="335.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.06"
					y1="335.89"
					x2="112.5"
					y2="336.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.5"
					y1="336.41"
					x2="104.06"
					y2="337.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.06"
					y1="337.96"
					x2="95.86"
					y2="340.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.86"
					y1="340.51"
					x2="88.04"
					y2="344.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.04"
					y1="344.03"
					x2="80.69"
					y2="348.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="80.69"
					y1="348.47"
					x2="73.94"
					y2="353.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="73.94"
					y1="353.77"
					x2="67.87"
					y2="359.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="67.87"
					y1="359.83"
					x2="62.58"
					y2="366.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="62.58"
					y1="366.59"
					x2="58.14"
					y2="373.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="58.14"
					y1="373.93"
					x2="54.62"
					y2="381.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="54.62"
					y1="381.76"
					x2="52.06"
					y2="389.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="52.06"
					y1="389.95"
					x2="50.52"
					y2="398.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="50.52"
					y1="398.39"
					x2="50"
					y2="406.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="50"
					y1="406.96"
					x2="50"
					y2="683.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="50"
					y1="683.8"
					x2="50"
					y2="686.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="806.87 315.62 806.87 318.82 831.53 318.82 831.53 315.62 806.87 315.62"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="832.69 315.33 805.71 315.33 805.71 315.62 832.69 315.62 832.69 315.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="832.69"
					y1="315.62"
					x2="832.69"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.71"
					y1="315.62"
					x2="832.69"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.71"
					y1="315.33"
					x2="805.71"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.69"
					y1="315.33"
					x2="805.71"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.87"
					y1="318.82"
					x2="831.53"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.53"
					y1="315.62"
					x2="806.87"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="804.25 318.82 806.87 318.82 806.87 315.62 804.25 315.62 804.25 318.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="804.25"
					y1="315.62"
					x2="804.25"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.87"
					y1="315.62"
					x2="804.25"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.87"
					y1="318.82"
					x2="806.87"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="804.25"
					y1="318.82"
					x2="806.87"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="834.15 315.62 831.53 315.62 831.53 318.82 834.15 318.82 834.15 315.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="834.15"
					y1="318.82"
					x2="834.15"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.53"
					y1="318.82"
					x2="834.15"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.53"
					y1="315.62"
					x2="831.53"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.15"
					y1="315.62"
					x2="831.53"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.87"
					y1="316.2"
					x2="831.53"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="803.09 318.53 804.25 318.53 804.25 315.62 805.71 315.62 805.71 315.33 803.09 315.33 803.09 318.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="803.09"
					y1="315.33"
					x2="803.09"
					y2="318.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.71"
					y1="315.33"
					x2="803.09"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="805.71"
					y1="315.62"
					x2="805.71"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="804.25"
					y1="315.62"
					x2="805.71"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="804.25"
					y1="318.53"
					x2="804.25"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.09"
					y1="318.53"
					x2="804.25"
					y2="318.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="835.31 315.33 832.69 315.33 832.69 315.62 834.15 315.62 834.15 318.53 835.31 318.53 835.31 315.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="835.31"
					y1="318.53"
					x2="835.31"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.15"
					y1="318.53"
					x2="835.31"
					y2="318.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.15"
					y1="315.62"
					x2="834.15"
					y2="318.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.69"
					y1="315.62"
					x2="834.15"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.69"
					y1="315.33"
					x2="832.69"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.31"
					y1="315.33"
					x2="832.69"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="836.79 316.2 836.79 317.68 896.53 317.68 896.53 316.2 836.79 316.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="896.53"
					y1="316.2"
					x2="836.79"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.53"
					y1="317.68"
					x2="896.53"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.79"
					y1="317.68"
					x2="896.53"
					y2="317.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.79"
					y1="316.2"
					x2="836.79"
					y2="317.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="803.09 316.2 803.09 325.08 800.12 325.08 800.12 316.2 803.09 316.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="803.09"
					y1="325.08"
					x2="803.09"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.12"
					y1="325.08"
					x2="803.09"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.12"
					y1="316.2"
					x2="800.12"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.09"
					y1="316.2"
					x2="800.12"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="838.27 316.2 838.27 325.08 835.31 325.08 835.31 316.2 838.27 316.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="838.27"
					y1="325.08"
					x2="838.27"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.31"
					y1="325.08"
					x2="838.27"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.31"
					y1="316.2"
					x2="835.31"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="838.27"
					y1="316.2"
					x2="835.31"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="898.01 316.2 898.01 325.08 895.05 325.08 895.05 316.2 898.01 316.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="898.01"
					y1="325.08"
					x2="898.01"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.05"
					y1="325.08"
					x2="898.01"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.05"
					y1="316.2"
					x2="895.05"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.01"
					y1="316.2"
					x2="895.05"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="489.63 315.62 489.63 318.82 514.28 318.82 514.28 315.62 489.63 315.62"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="515.44 315.33 488.46 315.33 488.46 315.62 515.44 315.62 515.44 315.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="515.44"
					y1="315.62"
					x2="515.44"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.46"
					y1="315.62"
					x2="515.44"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.46"
					y1="315.33"
					x2="488.46"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.44"
					y1="315.33"
					x2="488.46"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.63"
					y1="318.82"
					x2="514.28"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.28"
					y1="315.62"
					x2="489.63"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="487 318.82 489.63 318.82 489.63 315.62 487 315.62 487 318.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="487"
					y1="315.62"
					x2="487"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.63"
					y1="315.62"
					x2="487"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.63"
					y1="318.82"
					x2="489.63"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487"
					y1="318.82"
					x2="489.63"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="516.9 315.62 514.28 315.62 514.28 318.82 516.9 318.82 516.9 315.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="516.9"
					y1="318.82"
					x2="516.9"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.28"
					y1="318.82"
					x2="516.9"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.28"
					y1="315.62"
					x2="514.28"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.9"
					y1="315.62"
					x2="514.28"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.63"
					y1="316.2"
					x2="514.28"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="485.84 318.53 487 318.53 487 315.62 488.46 315.62 488.46 315.33 485.84 315.33 485.84 318.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="485.84"
					y1="315.33"
					x2="485.84"
					y2="318.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.46"
					y1="315.33"
					x2="485.84"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.46"
					y1="315.62"
					x2="488.46"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487"
					y1="315.62"
					x2="488.46"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487"
					y1="318.53"
					x2="487"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.84"
					y1="318.53"
					x2="487"
					y2="318.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="518.07 315.33 515.44 315.33 515.44 315.62 516.9 315.62 516.9 318.53 518.07 318.53 518.07 315.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="518.07"
					y1="318.53"
					x2="518.07"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.9"
					y1="318.53"
					x2="518.07"
					y2="318.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.9"
					y1="315.62"
					x2="516.9"
					y2="318.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.44"
					y1="315.62"
					x2="516.9"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.44"
					y1="315.33"
					x2="515.44"
					y2="315.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.07"
					y1="315.33"
					x2="515.44"
					y2="315.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="519.55 316.2 519.55 317.68 579.29 317.68 579.29 316.2 519.55 316.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="579.29"
					y1="316.2"
					x2="519.55"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.29"
					y1="317.68"
					x2="579.29"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.55"
					y1="317.68"
					x2="579.29"
					y2="317.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.55"
					y1="316.2"
					x2="519.55"
					y2="317.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="485.84 316.2 485.84 325.08 482.88 325.08 482.88 316.2 485.84 316.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="485.84"
					y1="325.08"
					x2="485.84"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.88"
					y1="325.08"
					x2="485.84"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.88"
					y1="316.2"
					x2="482.88"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.84"
					y1="316.2"
					x2="482.88"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="521.03 316.2 521.03 325.08 518.07 325.08 518.07 316.2 521.03 316.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="521.03"
					y1="325.08"
					x2="521.03"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.07"
					y1="325.08"
					x2="521.03"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.07"
					y1="316.2"
					x2="518.07"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.03"
					y1="316.2"
					x2="518.07"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="580.77 316.2 580.77 325.08 577.81 325.08 577.81 316.2 580.77 316.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="580.77"
					y1="325.08"
					x2="580.77"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.81"
					y1="325.08"
					x2="580.77"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.81"
					y1="316.2"
					x2="577.81"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.77"
					y1="316.2"
					x2="577.81"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="160.26 359.48 161.69 359.88 149.21 404.95 147.78 404.55 160.26 359.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="160.26"
					y1="359.48"
					x2="161.69"
					y2="359.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.69"
					y1="359.88"
					x2="149.21"
					y2="404.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.21"
					y1="404.95"
					x2="147.78"
					y2="404.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.78"
					y1="404.55"
					x2="160.26"
					y2="359.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="191.91 328.2 192.95 329.25 161.54 360.12 160.51 359.07 191.91 328.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="191.91"
					y1="328.2"
					x2="192.95"
					y2="329.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.95"
					y1="329.25"
					x2="161.54"
					y2="360.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.54"
					y1="360.12"
					x2="160.51"
					y2="359.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.51"
					y1="359.07"
					x2="191.91"
					y2="328.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="235.4 316.23 235.79 317.66 192.71 329.39 192.32 327.96 235.4 316.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="235.4"
					y1="316.23"
					x2="235.79"
					y2="317.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.79"
					y1="317.66"
					x2="192.71"
					y2="329.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.71"
					y1="329.39"
					x2="192.32"
					y2="327.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.32"
					y1="327.96"
					x2="235.4"
					y2="316.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="190.81 328.79 193.38 327.31 197.8 335.02 195.23 336.49 190.81 328.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="193.38"
					y1="327.31"
					x2="190.81"
					y2="328.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.8"
					y1="335.02"
					x2="193.38"
					y2="327.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.23"
					y1="336.49"
					x2="197.8"
					y2="335.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.81"
					y1="328.79"
					x2="195.23"
					y2="336.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="159.6 360.53 161.1 357.98 168.76 362.49 167.25 365.04 159.6 360.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="161.1"
					y1="357.98"
					x2="159.6"
					y2="360.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="168.76"
					y1="362.49"
					x2="161.1"
					y2="357.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.25"
					y1="365.04"
					x2="168.76"
					y2="362.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.6"
					y1="360.53"
					x2="167.25"
					y2="365.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.05"
					y1="646.8"
					x2="690.27"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688.05"
					y1="634.95"
					x2="690.27"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688.05"
					y1="634.95"
					x2="688.05"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="631.79"
					y1="646.8"
					x2="629.57"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="631.79"
					y1="634.95"
					x2="629.57"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="631.79"
					y1="634.95"
					x2="631.79"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="632.53 647.54 632.53 646.8 629.57 646.8 629.57 647.54 632.53 647.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="687.31 646.8 687.31 647.54 690.27 647.54 690.27 646.8 687.31 646.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="632.53 634.95 632.53 634.21 629.57 634.21 629.57 634.95 632.53 634.95"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="687.31 634.21 687.31 634.95 690.27 634.95 690.27 634.21 687.31 634.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="632.53"
					y1="647.54"
					x2="629.57"
					y2="647.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.57"
					y1="647.54"
					x2="629.57"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.57"
					y1="646.8"
					x2="632.53"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.53"
					y1="646.8"
					x2="632.53"
					y2="647.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.31"
					y1="646.8"
					x2="690.27"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.27"
					y1="646.8"
					x2="690.27"
					y2="647.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.27"
					y1="647.54"
					x2="687.31"
					y2="647.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.31"
					y1="647.54"
					x2="687.31"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.53"
					y1="634.95"
					x2="629.57"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.57"
					y1="634.95"
					x2="629.57"
					y2="634.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.57"
					y1="634.21"
					x2="632.53"
					y2="634.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.53"
					y1="634.21"
					x2="632.53"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.31"
					y1="634.21"
					x2="690.27"
					y2="634.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.27"
					y1="634.21"
					x2="690.27"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.27"
					y1="634.95"
					x2="687.31"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.31"
					y1="634.95"
					x2="687.31"
					y2="634.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="633.27 646.8 633.27 634.95 632.16 634.95 632.16 646.8 633.27 646.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="687.68 646.8 687.68 634.95 686.57 634.95 686.57 646.8 687.68 646.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="648.88 597.27 647.05 599.1 684.74 636.79 686.57 634.95 648.88 597.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="632.16"
					y1="634.95"
					x2="631.79"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.16"
					y1="646.8"
					x2="631.79"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.79"
					y1="634.95"
					x2="631.79"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.68"
					y1="634.95"
					x2="688.05"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.68"
					y1="646.8"
					x2="688.05"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.05"
					y1="634.95"
					x2="688.05"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.27"
					y1="646.8"
					x2="633.27"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.27"
					y1="634.95"
					x2="632.16"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.16"
					y1="634.95"
					x2="632.16"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.16"
					y1="646.8"
					x2="633.27"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.68"
					y1="646.8"
					x2="687.68"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.68"
					y1="634.95"
					x2="686.57"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.57"
					y1="634.95"
					x2="686.57"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.57"
					y1="646.8"
					x2="687.68"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.88"
					y1="597.27"
					x2="647.05"
					y2="599.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.05"
					y1="599.1"
					x2="684.74"
					y2="636.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.74"
					y1="636.79"
					x2="686.57"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.57"
					y1="634.95"
					x2="648.88"
					y2="597.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.79"
					y1="634.95"
					x2="631.79"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="631.79"
					y1="634.95"
					x2="631.79"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="631.79"
					y1="634.95"
					x2="629.57"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="631.79"
					y1="634.95"
					x2="629.57"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="631.79"
					y1="646.8"
					x2="629.57"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="631.79"
					y1="646.8"
					x2="629.57"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688.05"
					y1="634.95"
					x2="688.05"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688.05"
					y1="634.95"
					x2="688.05"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688.05"
					y1="634.95"
					x2="690.27"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688.05"
					y1="634.95"
					x2="690.27"
					y2="634.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688.05"
					y1="646.8"
					x2="690.27"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688.05"
					y1="646.8"
					x2="690.27"
					y2="646.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="898.01"
					y1="313.24"
					x2="898.01"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="706.35"
					y1="627.36"
					x2="706.35"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="627.36"
					x2="713.76"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="627.36"
					x2="706.35"
					y2="627.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="706.35"
					y1="579.98"
					x2="706.35"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="579.98"
					x2="713.76"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="579.98"
					x2="706.35"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="705.61 580.72 706.35 580.72 706.35 577.76 705.61 577.76 705.61 580.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="706.35 626.61 705.61 626.61 705.61 629.58 706.35 629.58 706.35 626.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="713.76 580.72 714.5 580.72 714.5 577.76 713.76 577.76 713.76 580.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="714.5 626.61 713.76 626.61 713.76 629.58 714.5 629.58 714.5 626.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="705.61"
					y1="580.72"
					x2="705.61"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.61"
					y1="577.76"
					x2="706.35"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="577.76"
					x2="706.35"
					y2="580.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="580.72"
					x2="705.61"
					y2="580.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="626.61"
					x2="706.35"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="629.58"
					x2="705.61"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.61"
					y1="629.58"
					x2="705.61"
					y2="626.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.61"
					y1="626.61"
					x2="706.35"
					y2="626.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="580.72"
					x2="713.76"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="577.76"
					x2="714.5"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.5"
					y1="577.76"
					x2="714.5"
					y2="580.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.5"
					y1="580.72"
					x2="713.76"
					y2="580.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.5"
					y1="626.61"
					x2="714.5"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.5"
					y1="629.58"
					x2="713.76"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="629.58"
					x2="713.76"
					y2="626.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="626.61"
					x2="714.5"
					y2="626.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="706.35 581.46 713.76 581.46 713.76 580.35 706.35 580.35 706.35 581.46"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="706.35 626.99 713.76 626.99 713.76 625.88 706.35 625.88 706.35 626.99"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="745.16 594.47 743.33 592.64 711.93 624.04 713.76 625.88 745.16 594.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="713.76"
					y1="580.35"
					x2="713.76"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="580.35"
					x2="706.35"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="579.98"
					x2="706.35"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="626.99"
					x2="713.76"
					y2="627.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="626.99"
					x2="706.35"
					y2="627.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="627.36"
					x2="706.35"
					y2="627.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="581.46"
					x2="713.76"
					y2="581.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="581.46"
					x2="713.76"
					y2="580.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="580.35"
					x2="706.35"
					y2="580.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="580.35"
					x2="706.35"
					y2="581.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="626.99"
					x2="713.76"
					y2="626.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="626.99"
					x2="713.76"
					y2="625.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="625.88"
					x2="706.35"
					y2="625.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.35"
					y1="625.88"
					x2="706.35"
					y2="626.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.16"
					y1="594.47"
					x2="743.33"
					y2="592.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.33"
					y1="592.64"
					x2="711.93"
					y2="624.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.93"
					y1="624.04"
					x2="713.76"
					y2="625.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="625.88"
					x2="745.16"
					y2="594.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.76"
					y1="579.98"
					x2="706.35"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="579.98"
					x2="706.35"
					y2="579.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="579.98"
					x2="713.76"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="579.98"
					x2="713.76"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="706.35"
					y1="579.98"
					x2="706.35"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="706.35"
					y1="579.98"
					x2="706.35"
					y2="577.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="627.36"
					x2="706.35"
					y2="627.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="627.36"
					x2="706.35"
					y2="627.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="627.36"
					x2="713.76"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="713.76"
					y1="627.36"
					x2="713.76"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="706.35"
					y1="627.36"
					x2="706.35"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="706.35"
					y1="627.36"
					x2="706.35"
					y2="629.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="469.76"
					x2="638.4"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="462.35"
					x2="638.4"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="462.35"
					x2="640.62"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688"
					y1="469.76"
					x2="690.22"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688"
					y1="462.35"
					x2="690.22"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688"
					y1="462.35"
					x2="688"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="462.35"
					x2="633.37"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="633.37"
					y1="469.76"
					x2="640.62"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="687.26 470.49 690.22 470.49 690.22 469.76 687.26 469.76 687.26 470.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="641.36 469.76 638.4 469.76 638.4 470.49 641.36 470.49 641.36 469.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="687.26 462.35 690.22 462.35 690.22 461.61 687.26 461.61 687.26 462.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="641.36 461.61 638.4 461.61 638.4 462.35 641.36 462.35 641.36 461.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="687.26"
					y1="470.49"
					x2="690.22"
					y2="470.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.22"
					y1="470.49"
					x2="690.22"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.22"
					y1="469.76"
					x2="687.26"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.26"
					y1="469.76"
					x2="687.26"
					y2="470.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.36"
					y1="469.76"
					x2="638.4"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.4"
					y1="469.76"
					x2="638.4"
					y2="470.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.4"
					y1="470.49"
					x2="641.36"
					y2="470.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.36"
					y1="470.49"
					x2="641.36"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.26"
					y1="462.35"
					x2="690.22"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.22"
					y1="462.35"
					x2="690.22"
					y2="461.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.22"
					y1="461.61"
					x2="687.26"
					y2="461.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.26"
					y1="461.61"
					x2="687.26"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.36"
					y1="461.61"
					x2="638.4"
					y2="461.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.4"
					y1="461.61"
					x2="638.4"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.4"
					y1="462.35"
					x2="641.36"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.36"
					y1="462.35"
					x2="641.36"
					y2="461.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="686.52 469.76 687.63 469.76 687.63 462.35 686.52 462.35 686.52 469.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="640.99 469.76 642.1 469.76 642.1 462.35 640.99 462.35 640.99 469.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="673.51 430.95 642.1 462.35 643.94 464.18 675.34 432.78 673.51 430.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="687.63"
					y1="462.35"
					x2="688"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.63"
					y1="469.76"
					x2="688"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688"
					y1="462.35"
					x2="688"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.99"
					y1="462.35"
					x2="640.62"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.99"
					y1="469.76"
					x2="640.62"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.62"
					y1="462.35"
					x2="640.62"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.52"
					y1="469.76"
					x2="686.52"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="686.52"
					y1="462.35"
					x2="687.63"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.63"
					y1="462.35"
					x2="687.63"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.63"
					y1="469.76"
					x2="686.52"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.99"
					y1="469.76"
					x2="640.99"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.99"
					y1="462.35"
					x2="642.1"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.1"
					y1="462.35"
					x2="642.1"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.1"
					y1="469.76"
					x2="640.99"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.51"
					y1="430.95"
					x2="675.34"
					y2="432.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.34"
					y1="432.78"
					x2="643.94"
					y2="464.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.94"
					y1="464.18"
					x2="642.1"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.1"
					y1="462.35"
					x2="673.51"
					y2="430.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688"
					y1="462.35"
					x2="688"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688"
					y1="462.35"
					x2="688"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688"
					y1="462.35"
					x2="690.22"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688"
					y1="462.35"
					x2="690.22"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688"
					y1="469.76"
					x2="690.22"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="688"
					y1="469.76"
					x2="690.22"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="462.35"
					x2="640.62"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="462.35"
					x2="640.62"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="462.35"
					x2="638.4"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="462.35"
					x2="638.4"
					y2="462.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="469.76"
					x2="638.4"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="640.62"
					y1="469.76"
					x2="638.4"
					y2="469.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="633.37"
					y1="462.35"
					x2="633.37"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.13"
					y1="472.8"
					x2="750.13"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="751.61"
					y1="472.8"
					x2="750.13"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="472.8"
					x2="757.53"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="472.8"
					x2="751.61"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.13"
					y1="542.11"
					x2="750.13"
					y2="543.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="751.61"
					y1="542.11"
					x2="750.13"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="542.11"
					x2="757.53"
					y2="543.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="542.11"
					x2="751.61"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="552.56"
					x2="757.53"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.13"
					y1="469.76"
					x2="750.13"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.13"
					y1="542.11"
					x2="750.13"
					y2="545.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="751.61 541 750.13 541 750.13 541.74 751.61 541.74 751.61 541"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="749.39 541 749.39 543.96 750.13 543.96 750.13 541 749.39 541"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="751.61 473.17 750.13 473.17 750.13 473.91 751.61 473.91 751.61 473.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="750.13 473.91 750.13 470.95 749.39 470.95 749.39 473.91 750.13 473.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="757.53 541 757.53 543.96 759.38 543.96 759.38 541 757.53 541"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="759.38 473.91 759.38 470.95 757.53 470.95 757.53 473.91 759.38 473.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="751.61"
					y1="541"
					x2="750.13"
					y2="541"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.13"
					y1="541"
					x2="750.13"
					y2="541.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.13"
					y1="541.74"
					x2="751.61"
					y2="541.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.61"
					y1="541.74"
					x2="751.61"
					y2="541"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.39"
					y1="541"
					x2="749.39"
					y2="543.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.39"
					y1="543.96"
					x2="750.13"
					y2="543.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.13"
					y1="543.96"
					x2="750.13"
					y2="541"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.13"
					y1="541"
					x2="749.39"
					y2="541"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.61"
					y1="473.17"
					x2="750.13"
					y2="473.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.13"
					y1="473.17"
					x2="750.13"
					y2="473.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.13"
					y1="473.91"
					x2="751.61"
					y2="473.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.61"
					y1="473.91"
					x2="751.61"
					y2="473.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.13"
					y1="473.91"
					x2="750.13"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.13"
					y1="470.95"
					x2="749.39"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.39"
					y1="470.95"
					x2="749.39"
					y2="473.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.39"
					y1="473.91"
					x2="750.13"
					y2="473.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="541"
					x2="757.53"
					y2="543.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="543.96"
					x2="759.38"
					y2="543.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.38"
					y1="543.96"
					x2="759.38"
					y2="541"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.38"
					y1="541"
					x2="757.53"
					y2="541"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.38"
					y1="473.91"
					x2="759.38"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.38"
					y1="470.95"
					x2="757.53"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="470.95"
					x2="757.53"
					y2="473.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="473.91"
					x2="759.38"
					y2="473.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="751.61 538.78 751.61 541.74 757.53 541.74 757.53 538.78 751.61 538.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="751.61 473.17 751.61 476.13 757.53 476.13 757.53 473.17 751.61 473.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="757.53 508.93 757.53 476.13 754.94 476.13 754.94 508.93 757.53 508.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="754.94 521.01 754.94 488.21 752.35 488.21 752.35 521.01 754.94 521.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="757.53"
					y1="541.74"
					x2="757.53"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.61"
					y1="541.74"
					x2="751.61"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="542.11"
					x2="751.61"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="473.17"
					x2="757.53"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.61"
					y1="473.17"
					x2="751.61"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="472.8"
					x2="751.61"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.61"
					y1="538.78"
					x2="757.53"
					y2="538.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="538.78"
					x2="757.53"
					y2="541.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="541.74"
					x2="751.61"
					y2="541.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.61"
					y1="541.74"
					x2="751.61"
					y2="538.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.61"
					y1="473.17"
					x2="757.53"
					y2="473.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="473.17"
					x2="757.53"
					y2="476.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="476.13"
					x2="751.61"
					y2="476.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.61"
					y1="476.13"
					x2="751.61"
					y2="473.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="508.93"
					x2="754.94"
					y2="508.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.94"
					y1="508.93"
					x2="754.94"
					y2="476.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.94"
					y1="476.13"
					x2="757.53"
					y2="476.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="476.13"
					x2="757.53"
					y2="508.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.94"
					y1="521.01"
					x2="752.35"
					y2="521.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="521.01"
					x2="752.35"
					y2="488.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.35"
					y1="488.21"
					x2="754.94"
					y2="488.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.94"
					y1="488.21"
					x2="754.94"
					y2="521.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="542.11"
					x2="751.61"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="542.11"
					x2="751.61"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="751.61"
					y1="542.11"
					x2="750.13"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="542.11"
					x2="757.53"
					y2="543.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="751.61"
					y1="542.11"
					x2="750.13"
					y2="542.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.13"
					y1="542.11"
					x2="750.13"
					y2="543.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.13"
					y1="542.11"
					x2="750.13"
					y2="543.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="472.8"
					x2="751.61"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="472.8"
					x2="751.61"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="751.61"
					y1="472.8"
					x2="750.13"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="757.53"
					y1="472.8"
					x2="757.53"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="751.61"
					y1="472.8"
					x2="750.13"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.13"
					y1="472.8"
					x2="750.13"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="750.13"
					y1="472.8"
					x2="750.13"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.09"
					y1="545.55"
					x2="624.31"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.09"
					y1="538.14"
					x2="624.31"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.09"
					y1="538.14"
					x2="622.09"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="574.72"
					y1="545.55"
					x2="572.5"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="574.72"
					y1="538.14"
					x2="572.5"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="574.72"
					y1="538.14"
					x2="574.72"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="625.96"
					y1="538.14"
					x2="622.09"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="575.46 546.28 575.46 545.55 572.5 545.55 572.5 546.28 575.46 546.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="621.35 545.55 621.35 546.28 624.31 546.28 624.31 545.55 621.35 545.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="575.46 538.14 575.46 537.4 572.5 537.4 572.5 538.14 575.46 538.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="621.35 537.4 621.35 538.14 624.31 538.14 624.31 537.4 621.35 537.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="575.46"
					y1="546.28"
					x2="572.5"
					y2="546.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.5"
					y1="546.28"
					x2="572.5"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.5"
					y1="545.55"
					x2="575.46"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.46"
					y1="545.55"
					x2="575.46"
					y2="546.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.35"
					y1="545.55"
					x2="624.31"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.31"
					y1="545.55"
					x2="624.31"
					y2="546.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.31"
					y1="546.28"
					x2="621.35"
					y2="546.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.35"
					y1="546.28"
					x2="621.35"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.46"
					y1="538.14"
					x2="572.5"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.5"
					y1="538.14"
					x2="572.5"
					y2="537.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.5"
					y1="537.4"
					x2="575.46"
					y2="537.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.46"
					y1="537.4"
					x2="575.46"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.35"
					y1="537.4"
					x2="624.31"
					y2="537.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.31"
					y1="537.4"
					x2="624.31"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.31"
					y1="538.14"
					x2="621.35"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.35"
					y1="538.14"
					x2="621.35"
					y2="537.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="576.2 545.55 576.2 538.14 575.09 538.14 575.09 545.55 576.2 545.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="621.72 545.55 621.72 538.14 620.61 538.14 620.61 545.55 621.72 545.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="589.21 506.74 587.38 508.57 618.78 539.97 620.61 538.14 589.21 506.74"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="575.09"
					y1="538.14"
					x2="574.72"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.09"
					y1="545.55"
					x2="574.72"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.72"
					y1="538.14"
					x2="574.72"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.72"
					y1="538.14"
					x2="622.09"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.72"
					y1="545.55"
					x2="622.09"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.09"
					y1="538.14"
					x2="622.09"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.2"
					y1="545.55"
					x2="576.2"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.2"
					y1="538.14"
					x2="575.09"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.09"
					y1="538.14"
					x2="575.09"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.09"
					y1="545.55"
					x2="576.2"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.72"
					y1="545.55"
					x2="621.72"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.72"
					y1="538.14"
					x2="620.61"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.61"
					y1="538.14"
					x2="620.61"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.61"
					y1="545.55"
					x2="621.72"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.21"
					y1="506.74"
					x2="587.38"
					y2="508.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.38"
					y1="508.57"
					x2="618.78"
					y2="539.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.78"
					y1="539.97"
					x2="620.61"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.61"
					y1="538.14"
					x2="589.21"
					y2="506.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.72"
					y1="538.14"
					x2="574.72"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="574.72"
					y1="538.14"
					x2="574.72"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="574.72"
					y1="538.14"
					x2="572.5"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="574.72"
					y1="538.14"
					x2="572.5"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="574.72"
					y1="545.55"
					x2="572.5"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="574.72"
					y1="545.55"
					x2="572.5"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.09"
					y1="538.14"
					x2="622.09"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.09"
					y1="538.14"
					x2="622.09"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.09"
					y1="538.14"
					x2="624.31"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.09"
					y1="538.14"
					x2="624.31"
					y2="538.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.09"
					y1="545.55"
					x2="624.31"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="622.09"
					y1="545.55"
					x2="624.31"
					y2="545.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="539.41"
					y1="513.36"
					x2="539.41"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="550.94"
					x2="536.4"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="558.34"
					x2="536.4"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="558.34"
					x2="534.17"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="486.8"
					y1="550.94"
					x2="484.58"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="486.8"
					y1="558.34"
					x2="484.58"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="486.8"
					y1="558.34"
					x2="486.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="550.94"
					x2="426.16"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="558.34"
					x2="426.16"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="558.34"
					x2="428.39"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="472.8"
					y1="550.94"
					x2="475.02"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="472.8"
					y1="558.34"
					x2="475.02"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="472.8"
					y1="558.34"
					x2="472.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="539.41"
					y1="550.94"
					x2="534.17"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="473.45"
					y1="550.94"
					x2="472.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="550.94"
					x2="427.74"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="558.34"
					x2="546.81"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="487.54 550.2 484.58 550.2 484.58 550.94 487.54 550.94 487.54 550.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="533.44 550.94 536.4 550.94 536.4 550.2 533.44 550.2 533.44 550.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="487.54 558.34 484.58 558.34 484.58 559.08 487.54 559.08 487.54 558.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="533.44 559.08 536.4 559.08 536.4 558.34 533.44 558.34 533.44 559.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="487.54"
					y1="550.2"
					x2="484.58"
					y2="550.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.58"
					y1="550.2"
					x2="484.58"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.58"
					y1="550.94"
					x2="487.54"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.54"
					y1="550.94"
					x2="487.54"
					y2="550.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.44"
					y1="550.94"
					x2="536.4"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.4"
					y1="550.94"
					x2="536.4"
					y2="550.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.4"
					y1="550.2"
					x2="533.44"
					y2="550.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.44"
					y1="550.2"
					x2="533.44"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.54"
					y1="558.34"
					x2="484.58"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.58"
					y1="558.34"
					x2="484.58"
					y2="559.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.58"
					y1="559.08"
					x2="487.54"
					y2="559.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.54"
					y1="559.08"
					x2="487.54"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.44"
					y1="559.08"
					x2="536.4"
					y2="559.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.4"
					y1="559.08"
					x2="536.4"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.4"
					y1="558.34"
					x2="533.44"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.44"
					y1="558.34"
					x2="533.44"
					y2="559.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="488.28 550.94 487.17 550.94 487.17 558.34 488.28 558.34 488.28 550.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="533.81 550.94 532.69 550.94 532.69 558.34 533.81 558.34 533.81 550.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="501.29 589.74 532.69 558.34 530.86 556.51 499.46 587.91 501.29 589.74"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="487.17"
					y1="558.34"
					x2="486.8"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.17"
					y1="550.94"
					x2="486.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.8"
					y1="558.34"
					x2="486.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.81"
					y1="558.34"
					x2="534.17"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.81"
					y1="550.94"
					x2="534.17"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.17"
					y1="558.34"
					x2="534.17"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.28"
					y1="550.94"
					x2="488.28"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.28"
					y1="558.34"
					x2="487.17"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.17"
					y1="558.34"
					x2="487.17"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.17"
					y1="550.94"
					x2="488.28"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.81"
					y1="550.94"
					x2="533.81"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.81"
					y1="558.34"
					x2="532.69"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.69"
					y1="558.34"
					x2="532.69"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.69"
					y1="550.94"
					x2="533.81"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.29"
					y1="589.74"
					x2="499.46"
					y2="587.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.46"
					y1="587.91"
					x2="530.86"
					y2="556.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.86"
					y1="556.51"
					x2="532.69"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.69"
					y1="558.34"
					x2="501.29"
					y2="589.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.8"
					y1="558.34"
					x2="486.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="486.8"
					y1="558.34"
					x2="486.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="486.8"
					y1="558.34"
					x2="484.58"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="486.8"
					y1="558.34"
					x2="484.58"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="486.8"
					y1="550.94"
					x2="484.58"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="486.8"
					y1="550.94"
					x2="484.58"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="558.34"
					x2="534.17"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="558.34"
					x2="534.17"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="558.34"
					x2="536.4"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="558.34"
					x2="536.4"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="550.94"
					x2="536.4"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="534.17"
					y1="550.94"
					x2="536.4"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="472.06 550.2 472.06 550.94 475.02 550.94 475.02 550.2 472.06 550.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="429.12 550.94 429.12 550.2 426.16 550.2 426.16 550.94 429.12 550.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="472.06 558.34 472.06 559.08 475.02 559.08 475.02 558.34 472.06 558.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="429.12 559.08 429.12 558.34 426.16 558.34 426.16 559.08 429.12 559.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="472.06"
					y1="550.2"
					x2="475.02"
					y2="550.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.02"
					y1="550.2"
					x2="475.02"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.02"
					y1="550.94"
					x2="472.06"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.06"
					y1="550.94"
					x2="472.06"
					y2="550.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.12"
					y1="550.94"
					x2="426.16"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.16"
					y1="550.94"
					x2="426.16"
					y2="550.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.16"
					y1="550.2"
					x2="429.12"
					y2="550.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.12"
					y1="550.2"
					x2="429.12"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.06"
					y1="558.34"
					x2="475.02"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.02"
					y1="558.34"
					x2="475.02"
					y2="559.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.02"
					y1="559.08"
					x2="472.06"
					y2="559.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.06"
					y1="559.08"
					x2="472.06"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.12"
					y1="559.08"
					x2="426.16"
					y2="559.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.16"
					y1="559.08"
					x2="426.16"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.16"
					y1="558.34"
					x2="429.12"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.12"
					y1="558.34"
					x2="429.12"
					y2="559.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="471.32 550.94 471.32 558.34 472.43 558.34 472.43 550.94 471.32 550.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="428.75 550.94 428.75 558.34 429.87 558.34 429.87 550.94 428.75 550.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="459.18 587.65 461.01 585.82 431.7 556.51 429.87 558.34 459.18 587.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="472.43"
					y1="558.34"
					x2="472.8"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.43"
					y1="550.94"
					x2="472.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.8"
					y1="558.34"
					x2="472.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.75"
					y1="558.34"
					x2="428.39"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.75"
					y1="550.94"
					x2="428.39"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.39"
					y1="558.34"
					x2="428.39"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.32"
					y1="550.94"
					x2="471.32"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.32"
					y1="558.34"
					x2="472.43"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.43"
					y1="558.34"
					x2="472.43"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.43"
					y1="550.94"
					x2="471.32"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.75"
					y1="550.94"
					x2="428.75"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.75"
					y1="558.34"
					x2="429.87"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.87"
					y1="558.34"
					x2="429.87"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.87"
					y1="550.94"
					x2="428.75"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.18"
					y1="587.65"
					x2="461.01"
					y2="585.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.01"
					y1="585.82"
					x2="431.7"
					y2="556.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.7"
					y1="556.51"
					x2="429.87"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.87"
					y1="558.34"
					x2="459.18"
					y2="587.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.8"
					y1="558.34"
					x2="472.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="472.8"
					y1="558.34"
					x2="472.8"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="472.8"
					y1="558.34"
					x2="475.02"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="472.8"
					y1="558.34"
					x2="475.02"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="472.8"
					y1="550.94"
					x2="475.02"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="472.8"
					y1="550.94"
					x2="475.02"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="558.34"
					x2="428.39"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="558.34"
					x2="428.39"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="558.34"
					x2="426.16"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="558.34"
					x2="426.16"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="550.94"
					x2="426.16"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="428.39"
					y1="550.94"
					x2="426.16"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="403.66"
					y1="373.18"
					x2="403.66"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="412.23"
					y1="373.18"
					x2="403.66"
					y2="373.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="473.45"
					y1="513.36"
					x2="473.45"
					y2="550.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="456.52"
					y1="492.22"
					x2="456.52"
					y2="494.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458"
					y1="492.22"
					x2="456.52"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="492.22"
					x2="463.92"
					y2="494.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="492.22"
					x2="458"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="456.52"
					y1="384.89"
					x2="456.52"
					y2="383.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458"
					y1="384.89"
					x2="456.52"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="384.89"
					x2="463.92"
					y2="383.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="384.89"
					x2="458"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="505.96"
					x2="463.92"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="456.52"
					y1="372.52"
					x2="456.52"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="456.52"
					y1="492.22"
					x2="456.52"
					y2="505.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="458 386.01 458 385.26 456.52 385.26 456.52 386.01 458 386.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="455.78 386.01 456.52 386.01 456.52 383.05 455.78 383.05 455.78 386.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="458 491.85 458 491.11 456.52 491.11 456.52 491.85 458 491.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="456.52 491.11 455.78 491.11 455.78 494.07 456.52 494.07 456.52 491.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="463.92 386.01 465.77 386.01 465.77 383.05 463.92 383.05 463.92 386.01"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="465.77 491.11 463.92 491.11 463.92 494.07 465.77 494.07 465.77 491.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="458"
					y1="386.01"
					x2="456.52"
					y2="386.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.52"
					y1="386.01"
					x2="456.52"
					y2="385.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.52"
					y1="385.26"
					x2="458"
					y2="385.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458"
					y1="385.26"
					x2="458"
					y2="386.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.78"
					y1="386.01"
					x2="455.78"
					y2="383.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.78"
					y1="383.05"
					x2="456.52"
					y2="383.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.52"
					y1="383.05"
					x2="456.52"
					y2="386.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.52"
					y1="386.01"
					x2="455.78"
					y2="386.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458"
					y1="491.85"
					x2="456.52"
					y2="491.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.52"
					y1="491.85"
					x2="456.52"
					y2="491.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.52"
					y1="491.11"
					x2="458"
					y2="491.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458"
					y1="491.11"
					x2="458"
					y2="491.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.52"
					y1="491.11"
					x2="456.52"
					y2="494.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.52"
					y1="494.07"
					x2="455.78"
					y2="494.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.78"
					y1="494.07"
					x2="455.78"
					y2="491.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.78"
					y1="491.11"
					x2="456.52"
					y2="491.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="386.01"
					x2="463.92"
					y2="383.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="383.05"
					x2="465.77"
					y2="383.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.77"
					y1="383.05"
					x2="465.77"
					y2="386.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.77"
					y1="386.01"
					x2="463.92"
					y2="386.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.77"
					y1="491.11"
					x2="465.77"
					y2="494.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.77"
					y1="494.07"
					x2="463.92"
					y2="494.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="494.07"
					x2="463.92"
					y2="491.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="491.11"
					x2="465.77"
					y2="491.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="458 388.23 463.92 388.23 463.92 385.26 458 385.26 458 388.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="458 491.85 463.92 491.85 463.92 488.89 458 488.89 458 491.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="463.92 437.08 461.33 437.08 461.33 488.89 463.92 488.89 463.92 437.08"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="461.33 405.99 458.74 405.99 458.74 457.8 461.33 457.8 461.33 405.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="463.92"
					y1="385.26"
					x2="463.92"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458"
					y1="385.26"
					x2="458"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="384.89"
					x2="458"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="491.85"
					x2="463.92"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458"
					y1="491.85"
					x2="458"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="492.22"
					x2="458"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458"
					y1="388.23"
					x2="463.92"
					y2="388.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="388.23"
					x2="463.92"
					y2="385.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="385.26"
					x2="458"
					y2="385.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458"
					y1="385.26"
					x2="458"
					y2="388.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458"
					y1="491.85"
					x2="463.92"
					y2="491.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="491.85"
					x2="463.92"
					y2="488.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="488.89"
					x2="458"
					y2="488.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458"
					y1="488.89"
					x2="458"
					y2="491.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="437.08"
					x2="461.33"
					y2="437.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.33"
					y1="437.08"
					x2="461.33"
					y2="488.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.33"
					y1="488.89"
					x2="463.92"
					y2="488.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="488.89"
					x2="463.92"
					y2="437.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.33"
					y1="405.99"
					x2="458.74"
					y2="405.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.74"
					y1="405.99"
					x2="458.74"
					y2="457.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.74"
					y1="457.8"
					x2="461.33"
					y2="457.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.33"
					y1="457.8"
					x2="461.33"
					y2="405.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.92"
					y1="384.89"
					x2="458"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="384.89"
					x2="458"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458"
					y1="384.89"
					x2="456.52"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="384.89"
					x2="463.92"
					y2="383.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458"
					y1="384.89"
					x2="456.52"
					y2="384.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="456.52"
					y1="384.89"
					x2="456.52"
					y2="383.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="456.52"
					y1="384.89"
					x2="456.52"
					y2="383.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="492.22"
					x2="458"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="492.22"
					x2="458"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458"
					y1="492.22"
					x2="456.52"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.92"
					y1="492.22"
					x2="463.92"
					y2="494.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="458"
					y1="492.22"
					x2="456.52"
					y2="492.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="456.52"
					y1="492.22"
					x2="456.52"
					y2="494.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="456.52"
					y1="492.22"
					x2="456.52"
					y2="494.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="419.63"
					y1="372.52"
					x2="456.52"
					y2="372.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="156.71"
					y1="494.18"
					x2="156.71"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="494.18"
					x2="144.87"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="494.18"
					x2="156.71"
					y2="494.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="156.71"
					y1="550.44"
					x2="156.71"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="550.44"
					x2="144.87"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="550.44"
					x2="156.71"
					y2="550.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="156.71"
					y1="405.15"
					x2="144.87"
					y2="405.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="157.45 549.7 156.71 549.7 156.71 552.66 157.45 552.66 157.45 549.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="156.71 494.92 157.45 494.92 157.45 491.96 156.71 491.96 156.71 494.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="144.87 549.7 144.13 549.7 144.13 552.66 144.87 552.66 144.87 549.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="144.13 494.92 144.87 494.92 144.87 491.96 144.13 491.96 144.13 494.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="157.45"
					y1="549.7"
					x2="157.45"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.45"
					y1="552.66"
					x2="156.71"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="552.66"
					x2="156.71"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="549.7"
					x2="157.45"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="494.92"
					x2="156.71"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="491.96"
					x2="157.45"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.45"
					y1="491.96"
					x2="157.45"
					y2="494.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.45"
					y1="494.92"
					x2="156.71"
					y2="494.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="549.7"
					x2="144.87"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="552.66"
					x2="144.13"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.13"
					y1="552.66"
					x2="144.13"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.13"
					y1="549.7"
					x2="144.87"
					y2="549.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.13"
					y1="494.92"
					x2="144.13"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.13"
					y1="491.96"
					x2="144.87"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="491.96"
					x2="144.87"
					y2="494.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="494.92"
					x2="144.13"
					y2="494.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="156.71 548.96 144.87 548.96 144.87 550.07 156.71 550.07 156.71 548.96"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="156.71 494.55 144.87 494.55 144.87 495.66 156.71 495.66 156.71 494.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="107.18 533.35 109.01 535.18 146.7 497.49 144.87 495.66 107.18 533.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="144.87"
					y1="550.07"
					x2="144.87"
					y2="550.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="550.07"
					x2="156.71"
					y2="550.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="550.44"
					x2="156.71"
					y2="550.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="494.55"
					x2="144.87"
					y2="494.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="494.55"
					x2="156.71"
					y2="494.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="494.18"
					x2="156.71"
					y2="494.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="548.96"
					x2="144.87"
					y2="548.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="548.96"
					x2="144.87"
					y2="550.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="550.07"
					x2="156.71"
					y2="550.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="550.07"
					x2="156.71"
					y2="548.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="494.55"
					x2="144.87"
					y2="494.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="494.55"
					x2="144.87"
					y2="495.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="495.66"
					x2="156.71"
					y2="495.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.71"
					y1="495.66"
					x2="156.71"
					y2="494.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.18"
					y1="533.35"
					x2="109.01"
					y2="535.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.01"
					y1="535.18"
					x2="146.7"
					y2="497.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="146.7"
					y1="497.49"
					x2="144.87"
					y2="495.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="495.66"
					x2="107.18"
					y2="533.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.87"
					y1="550.44"
					x2="156.71"
					y2="550.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="550.44"
					x2="156.71"
					y2="550.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="550.44"
					x2="144.87"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="550.44"
					x2="144.87"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="156.71"
					y1="550.44"
					x2="156.71"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="156.71"
					y1="550.44"
					x2="156.71"
					y2="552.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="494.18"
					x2="156.71"
					y2="494.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="494.18"
					x2="156.71"
					y2="494.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="494.18"
					x2="144.87"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="144.87"
					y1="494.18"
					x2="144.87"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="156.71"
					y1="494.18"
					x2="156.71"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="156.71"
					y1="494.18"
					x2="156.71"
					y2="491.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="235.65"
					y1="313.24"
					x2="235.65"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="482.88"
					y1="325.08"
					x2="482.88"
					y2="313.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="580.77"
					y1="313.24"
					x2="580.77"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="633.37"
					y1="325.08"
					x2="719.63"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="800.12"
					y1="325.08"
					x2="800.12"
					y2="313.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="719.63"
					y1="369.57"
					x2="633.37"
					y2="369.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.37"
					y1="369.57"
					x2="633.37"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.37"
					y1="325.08"
					x2="719.63"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="714.23 330.35 714.23 363.72 639.14 363.72 639.14 330.35 714.23 330.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="714.23"
					y1="330.35"
					x2="714.23"
					y2="363.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.23"
					y1="363.72"
					x2="639.14"
					y2="363.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.14"
					y1="363.72"
					x2="639.14"
					y2="330.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.14"
					y1="330.35"
					x2="714.23"
					y2="330.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="706.85 347.33 706.88 347.03 706.95 346.74 707.07 346.46 707.23 346.22 707.44 346 707.67 345.83 707.93 345.71 708.21 345.63 708.5 345.6 708.78 345.63 709.06 345.71 709.32 345.83 709.56 346 709.76 346.22 709.92 346.46 710.04 346.74 710.12 347.03 710.15 347.33 710.12 347.63 710.04 347.92 709.92 348.19 709.76 348.44 709.56 348.65 709.32 348.82 709.06 348.95 708.78 349.03 708.5 349.05 708.21 349.03 707.93 348.95 707.67 348.82 707.44 348.65 707.23 348.44 707.07 348.19 706.95 347.92 706.88 347.63 706.85 347.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="706.85"
					y1="347.33"
					x2="706.88"
					y2="347.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.88"
					y1="347.03"
					x2="706.95"
					y2="346.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.95"
					y1="346.74"
					x2="707.07"
					y2="346.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.07"
					y1="346.46"
					x2="707.23"
					y2="346.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.23"
					y1="346.22"
					x2="707.44"
					y2="346"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.44"
					y1="346"
					x2="707.67"
					y2="345.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.67"
					y1="345.83"
					x2="707.93"
					y2="345.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.93"
					y1="345.71"
					x2="708.21"
					y2="345.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.21"
					y1="345.63"
					x2="708.5"
					y2="345.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.5"
					y1="345.6"
					x2="708.78"
					y2="345.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.78"
					y1="345.63"
					x2="709.06"
					y2="345.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.06"
					y1="345.71"
					x2="709.32"
					y2="345.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.32"
					y1="345.83"
					x2="709.56"
					y2="346"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.56"
					y1="346"
					x2="709.76"
					y2="346.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.76"
					y1="346.22"
					x2="709.92"
					y2="346.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.92"
					y1="346.46"
					x2="710.04"
					y2="346.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.04"
					y1="346.74"
					x2="710.12"
					y2="347.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.12"
					y1="347.03"
					x2="710.15"
					y2="347.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.15"
					y1="347.33"
					x2="710.12"
					y2="347.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.12"
					y1="347.63"
					x2="710.04"
					y2="347.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.04"
					y1="347.92"
					x2="709.92"
					y2="348.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.92"
					y1="348.19"
					x2="709.76"
					y2="348.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.76"
					y1="348.44"
					x2="709.56"
					y2="348.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.56"
					y1="348.65"
					x2="709.32"
					y2="348.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.32"
					y1="348.82"
					x2="709.06"
					y2="348.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.06"
					y1="348.95"
					x2="708.78"
					y2="349.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.78"
					y1="349.03"
					x2="708.5"
					y2="349.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.5"
					y1="349.05"
					x2="708.21"
					y2="349.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.21"
					y1="349.03"
					x2="707.93"
					y2="348.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.93"
					y1="348.95"
					x2="707.67"
					y2="348.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.67"
					y1="348.82"
					x2="707.44"
					y2="348.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.44"
					y1="348.65"
					x2="707.23"
					y2="348.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.23"
					y1="348.44"
					x2="707.07"
					y2="348.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.07"
					y1="348.19"
					x2="706.95"
					y2="347.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.95"
					y1="347.92"
					x2="706.88"
					y2="347.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.88"
					y1="347.63"
					x2="706.85"
					y2="347.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="716.16 348.81 713.77 348.58 713.58 348.54 713.4 348.48 713.23 348.38 710.22 347.99 710.11 347.96 710.02 347.92 709.92 347.86 709.84 347.79 709.77 347.7 709.72 347.6 709.68 347.49 709.67 347.38 709.67 347.27 709.68 347.16 709.72 347.05 709.77 346.95 709.84 346.87 709.92 346.79 710.02 346.73 710.11 346.69 710.22 346.67 713.23 346.27 713.4 346.18 713.58 346.11 713.77 346.08 716.16 345.84 716.4 345.86 716.64 345.93 716.87 346.04 717.07 346.19 717.24 346.37 717.39 346.58 717.49 346.82 717.56 347.07 717.58 347.33 717.56 347.58 717.49 347.84 717.39 348.07 717.24 348.28 717.07 348.47 716.87 348.62 716.64 348.72 716.4 348.79 716.16 348.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="716.16"
					y1="348.81"
					x2="713.77"
					y2="348.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.23"
					y1="348.38"
					x2="710.22"
					y2="347.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.22"
					y1="346.67"
					x2="713.23"
					y2="346.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.77"
					y1="346.08"
					x2="716.16"
					y2="345.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.74"
					y1="346.52"
					x2="713.89"
					y2="346.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.89"
					y1="348.14"
					x2="714.74"
					y2="348.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.74"
					y1="348.14"
					x2="714.74"
					y2="346.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m713.77,348.58c-.19-.02-.38-.09-.54-.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m710.22,347.99c-.32-.04-.56-.32-.56-.66s.24-.62.56-.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m713.23,346.27c.16-.11.35-.18.54-.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m716.16,345.84c.79,0,1.42.67,1.42,1.49s-.64,1.49-1.42,1.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m713.89,348.14c-.43,0-.77-.36-.77-.81s.35-.81.77-.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m713.23,348.38c-.34-.23-.55-.63-.55-1.06s.21-.82.55-1.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.29"
					y1="407.43"
					x2="710.29"
					y2="369.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.29"
					y1="407.43"
					x2="739.88"
					y2="407.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.31"
					y1="403.31"
					x2="717.31"
					y2="373.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.31"
					y1="373.7"
					x2="735.08"
					y2="373.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.08"
					y1="373.7"
					x2="735.08"
					y2="403.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.08"
					y1="403.31"
					x2="717.31"
					y2="403.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.15"
					y1="404.47"
					x2="716.15"
					y2="372.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.15"
					y1="372.53"
					x2="736.25"
					y2="372.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.25"
					y1="372.53"
					x2="736.25"
					y2="404.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.25"
					y1="404.47"
					x2="716.15"
					y2="404.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m732.82,388.5c0-.96-.78-1.75-1.75-1.75s-1.75.78-1.75,1.75.78,1.75,1.75,1.75,1.75-.78,1.75-1.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="738.29 389.96 735.84 389.73 735.28 389.54 732.2 389.15 731.79 388.93 731.63 388.5 731.79 388.07 732.2 387.85 735.28 387.47 735.84 387.28 738.29 387.05 739.31 387.47 739.74 388.5 739.31 389.53 738.29 389.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.29"
					y1="389.96"
					x2="735.84"
					y2="389.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m735.84,389.73c-.2-.02-.39-.08-.56-.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.28"
					y1="389.54"
					x2="732.2"
					y2="389.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m732.2,389.15c-.32-.04-.57-.32-.57-.65s.25-.61.57-.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.2"
					y1="387.85"
					x2="735.28"
					y2="387.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m735.28,387.47c.17-.11.36-.17.56-.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.84"
					y1="387.28"
					x2="738.29"
					y2="387.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m738.29,387.05c.8,0,1.46.65,1.46,1.46s-.66,1.46-1.46,1.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.83"
					y1="387.71"
					x2="735.97"
					y2="387.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.97"
					y1="389.3"
					x2="736.83"
					y2="389.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.83"
					y1="389.3"
					x2="736.83"
					y2="387.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m735.97,389.3c-.44,0-.79-.36-.79-.79s.36-.79.79-.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m735.28,389.54c-.35-.23-.56-.62-.56-1.04s.21-.81.56-1.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="701.01 426.95 699.83 429.59 699.42 432.46 699.83 435.32 701.01 437.96 702.5 439.7 704.38 441.02 708.79 442.7 714.3 443.28 719.7 442.05 724.56 442.45 729 444.48 730.25 445.27 732.82 446.21 735.56 446.07 736.63 445.65 739.51 445.65 739.51 444.45 738.2 444.45 739.41 442.44 739.88 440.14 739.88 424.77 739.08 421.79 736.97 419.56 734.04 418.6 733.69 418.6 731.84 418.91 728.93 420.47 724.54 422.48 719.74 422.88 714.32 421.63 708.79 422.21 704.38 423.89 702.5 425.21 701.01 426.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="726.21"
					y1="437.93"
					x2="726.21"
					y2="426.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.88"
					y1="424.77"
					x2="739.88"
					y2="432.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.33"
					y1="424.77"
					x2="739.33"
					y2="432.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.88"
					y1="440.14"
					x2="739.88"
					y2="432.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.33"
					y1="440.14"
					x2="739.33"
					y2="432.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.21"
					y1="427.26"
					x2="728.26"
					y2="427.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.26"
					y1="427.26"
					x2="728.26"
					y2="428.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.26"
					y1="428.95"
					x2="726.21"
					y2="428.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.21"
					y1="437.65"
					x2="728.26"
					y2="437.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.26"
					y1="437.65"
					x2="728.26"
					y2="435.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.26"
					y1="435.96"
					x2="726.21"
					y2="435.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.42"
					y1="444.45"
					x2="739.51"
					y2="444.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.42"
					y1="445.65"
					x2="739.51"
					y2="445.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.51"
					y1="445.65"
					x2="739.51"
					y2="444.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.42"
					y1="445.65"
					x2="734.42"
					y2="444.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.42"
					y1="432.46"
					x2="699.63"
					y2="430.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.63"
					y1="430.62"
					x2="700.1"
					y2="428.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.1"
					y1="428.84"
					x2="701.01"
					y2="426.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.01"
					y1="426.95"
					x2="702.5"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.5"
					y1="425.2"
					x2="704.38"
					y2="423.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.38"
					y1="423.89"
					x2="706.51"
					y2="422.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.51"
					y1="422.91"
					x2="708.79"
					y2="422.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.79"
					y1="422.21"
					x2="712.45"
					y2="421.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.45"
					y1="421.57"
					x2="716.14"
					y2="421.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.14"
					y1="421.74"
					x2="719"
					y2="422.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719"
					y1="422.58"
					x2="721.77"
					y2="423.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.77"
					y1="423.87"
					x2="724.24"
					y2="425.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.24"
					y1="425.41"
					x2="726.21"
					y2="426.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.74"
					y1="422.88"
					x2="722.31"
					y2="422.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.31"
					y1="422.86"
					x2="724.81"
					y2="422.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.81"
					y1="422.44"
					x2="727.48"
					y2="421.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.48"
					y1="421.38"
					x2="731.43"
					y2="419.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.43"
					y1="419.05"
					x2="733.39"
					y2="418.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.39"
					y1="418.62"
					x2="735.34"
					y2="418.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.34"
					y1="418.78"
					x2="737.12"
					y2="419.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.12"
					y1="419.54"
					x2="738.54"
					y2="420.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.54"
					y1="420.89"
					x2="739.27"
					y2="422.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.27"
					y1="422.2"
					x2="739.68"
					y2="423.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.68"
					y1="423.45"
					x2="739.88"
					y2="424.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.33"
					y1="424.77"
					x2="738.9"
					y2="422.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.9"
					y1="422.97"
					x2="738"
					y2="421.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738"
					y1="421.9"
					x2="736.75"
					y2="421.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.75"
					y1="421.23"
					x2="735.1"
					y2="420.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="420.91"
					x2="733.39"
					y2="420.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.39"
					y1="420.84"
					x2="732.55"
					y2="420.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.55"
					y1="420.85"
					x2="731.88"
					y2="421.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.88"
					y1="421.21"
					x2="731.68"
					y2="421.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.68"
					y1="421.62"
					x2="730.36"
					y2="426.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.36"
					y1="426.27"
					x2="729.8"
					y2="430.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.8"
					y1="430.93"
					x2="729.8"
					y2="432.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.7"
					y1="442.05"
					x2="722.28"
					y2="442.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.28"
					y1="442.06"
					x2="724.79"
					y2="442.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.79"
					y1="442.48"
					x2="727.48"
					y2="443.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.48"
					y1="443.53"
					x2="731.43"
					y2="445.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.43"
					y1="445.86"
					x2="732.74"
					y2="446.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.74"
					y1="446.22"
					x2="734.08"
					y2="446.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.08"
					y1="446.3"
					x2="735.4"
					y2="446.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.4"
					y1="446.11"
					x2="736.63"
					y2="445.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.33"
					y1="440.14"
					x2="738.9"
					y2="441.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.9"
					y1="441.94"
					x2="738"
					y2="443.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738"
					y1="443.01"
					x2="736.75"
					y2="443.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.75"
					y1="443.68"
					x2="735.1"
					y2="444"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="444"
					x2="733.39"
					y2="444.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.39"
					y1="444.07"
					x2="732.55"
					y2="444.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.55"
					y1="444.06"
					x2="731.88"
					y2="443.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.88"
					y1="443.7"
					x2="731.68"
					y2="443.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.68"
					y1="443.29"
					x2="730.36"
					y2="438.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.36"
					y1="438.63"
					x2="729.8"
					y2="433.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.8"
					y1="433.98"
					x2="729.8"
					y2="432.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.42"
					y1="432.46"
					x2="699.63"
					y2="434.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="699.63"
					y1="434.29"
					x2="700.1"
					y2="436.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.1"
					y1="436.07"
					x2="701.01"
					y2="437.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.01"
					y1="437.96"
					x2="702.5"
					y2="439.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="702.5"
					y1="439.7"
					x2="704.38"
					y2="441.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.38"
					y1="441.02"
					x2="706.51"
					y2="441.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.51"
					y1="441.99"
					x2="708.79"
					y2="442.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.79"
					y1="442.7"
					x2="712.45"
					y2="443.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.45"
					y1="443.34"
					x2="716.14"
					y2="443.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.14"
					y1="443.16"
					x2="719"
					y2="442.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719"
					y1="442.33"
					x2="721.77"
					y2="441.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.77"
					y1="441.04"
					x2="724.24"
					y2="439.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.24"
					y1="439.5"
					x2="726.21"
					y2="437.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.36"
					y1="419.57"
					x2="729.32"
					y2="420.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.32"
					y1="420.71"
					x2="729.17"
					y2="421.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.17"
					y1="421.44"
					x2="728.59"
					y2="430.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.59"
					y1="430.9"
					x2="728.59"
					y2="432.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.36"
					y1="445.34"
					x2="729.32"
					y2="444.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.32"
					y1="444.2"
					x2="729.17"
					y2="443.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.17"
					y1="443.47"
					x2="728.59"
					y2="434.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.59"
					y1="434.01"
					x2="728.59"
					y2="432.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.2"
					y1="444.45"
					x2="738.54"
					y2="444.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.54"
					y1="444.02"
					x2="739.27"
					y2="442.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.27"
					y1="442.71"
					x2="739.68"
					y2="441.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.68"
					y1="441.45"
					x2="739.88"
					y2="440.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="739.88 414.69 739.29 414.69 739.29 417.65 739.88 417.65 739.88 414.69"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="739.88"
					y1="417.65"
					x2="739.88"
					y2="414.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.29"
					y1="417.65"
					x2="739.88"
					y2="417.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.29"
					y1="414.69"
					x2="739.29"
					y2="417.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.88"
					y1="414.69"
					x2="739.29"
					y2="414.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="739.88 450.22 739.88 447.26 739.29 447.26 739.29 450.22 739.88 450.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="739.29"
					y1="450.22"
					x2="739.88"
					y2="450.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.29"
					y1="447.26"
					x2="739.29"
					y2="450.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.88"
					y1="447.26"
					x2="739.29"
					y2="447.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.88"
					y1="450.22"
					x2="739.88"
					y2="447.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="739.29 415.87 734.47 415.87 734.47 416.46 739.29 416.46 739.29 415.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="739.29"
					y1="416.46"
					x2="739.29"
					y2="415.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.47"
					y1="416.46"
					x2="739.29"
					y2="416.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.47"
					y1="415.87"
					x2="734.47"
					y2="416.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.29"
					y1="415.87"
					x2="734.47"
					y2="415.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="739.29 449.04 739.29 448.44 734.47 448.44 734.47 449.04 739.29 449.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="734.47"
					y1="449.04"
					x2="739.29"
					y2="449.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.47"
					y1="448.44"
					x2="734.47"
					y2="449.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.29"
					y1="448.44"
					x2="734.47"
					y2="448.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.29"
					y1="449.04"
					x2="739.29"
					y2="448.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="735.95 416.46 734.77 416.46 734.77 448.44 735.95 448.44 735.95 416.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="735.95"
					y1="448.44"
					x2="735.95"
					y2="416.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.77"
					y1="448.44"
					x2="735.95"
					y2="448.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.77"
					y1="416.46"
					x2="734.77"
					y2="448.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.95"
					y1="416.46"
					x2="734.77"
					y2="416.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.23"
					y1="325.08"
					x2="360.88"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.88"
					y1="373.18"
					x2="412.23"
					y2="373.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.88"
					y1="325.08"
					x2="360.88"
					y2="373.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.58"
					y1="325.08"
					x2="364.58"
					y2="373.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="368.12 478.81 401.91 478.81 401.91 512.01 368.12 512.01 368.12 478.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="368.12"
					y1="478.81"
					x2="369.74"
					y2="478.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.87"
					y1="478.81"
					x2="375.42"
					y2="478.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.55"
					y1="478.81"
					x2="381.11"
					y2="478.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.24"
					y1="478.81"
					x2="386.79"
					y2="478.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.92"
					y1="478.81"
					x2="392.48"
					y2="478.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.61"
					y1="478.81"
					x2="398.16"
					y2="478.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.29"
					y1="478.81"
					x2="401.91"
					y2="478.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="478.81"
					x2="401.91"
					y2="480.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="482.26"
					x2="401.91"
					y2="485.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="487.95"
					x2="401.91"
					y2="491.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="493.63"
					x2="401.91"
					y2="497.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="499.32"
					x2="401.91"
					y2="502.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="505"
					x2="401.91"
					y2="508.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="510.69"
					x2="401.91"
					y2="512.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="512.01"
					x2="400.29"
					y2="512.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.16"
					y1="512.01"
					x2="394.61"
					y2="512.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.48"
					y1="512.01"
					x2="388.92"
					y2="512.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.79"
					y1="512.01"
					x2="383.24"
					y2="512.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.11"
					y1="512.01"
					x2="377.55"
					y2="512.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.42"
					y1="512.01"
					x2="371.87"
					y2="512.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.74"
					y1="512.01"
					x2="368.12"
					y2="512.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="512.01"
					x2="368.12"
					y2="510.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="508.56"
					x2="368.12"
					y2="505"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="502.87"
					x2="368.12"
					y2="499.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="497.19"
					x2="368.12"
					y2="493.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="491.5"
					x2="368.12"
					y2="487.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="485.82"
					x2="368.12"
					y2="482.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="480.13"
					x2="368.12"
					y2="478.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="366.37 511.89 365.35 511.89 365.35 478.94 366.37 478.94 366.37 484.1 365.54 484.1 365.54 506.72 366.37 506.72 366.37 511.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="366.37"
					y1="511.89"
					x2="365.35"
					y2="511.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="365.35"
					y1="511.89"
					x2="365.35"
					y2="478.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="365.35"
					y1="478.94"
					x2="366.37"
					y2="478.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="366.37"
					y1="478.94"
					x2="366.37"
					y2="484.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="366.37"
					y1="484.1"
					x2="365.54"
					y2="484.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="365.54"
					y1="484.1"
					x2="365.54"
					y2="506.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="365.54"
					y1="506.72"
					x2="366.37"
					y2="506.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="366.37"
					y1="506.72"
					x2="366.37"
					y2="511.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<polyline
					points="366.37 513.18 366.37 477.65 368.12 477.65 368.12 513.18 366.37 513.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="366.37"
					y1="513.18"
					x2="366.37"
					y2="477.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="366.37"
					y1="477.65"
					x2="368.12"
					y2="477.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="368.12"
					y1="477.65"
					x2="368.12"
					y2="513.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="368.12"
					y1="513.18"
					x2="366.37"
					y2="513.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="366.37"
					y1="478.94"
					x2="365.35"
					y2="478.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.35"
					y1="478.94"
					x2="365.35"
					y2="511.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.35"
					y1="511.89"
					x2="366.37"
					y2="511.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.37"
					y1="477.65"
					x2="366.37"
					y2="513.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.37"
					y1="506.72"
					x2="365.54"
					y2="506.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.54"
					y1="506.72"
					x2="365.54"
					y2="484.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.54"
					y1="484.1"
					x2="366.37"
					y2="484.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="477.65"
					x2="366.37"
					y2="477.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.37"
					y1="513.18"
					x2="368.12"
					y2="513.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="513.18"
					x2="368.12"
					y2="477.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="365.16 432.14 403.66 432.14 403.66 387.73 365.16 387.73 365.16 432.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="365.16"
					y1="432.14"
					x2="365.16"
					y2="387.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.66"
					y1="432.14"
					x2="403.66"
					y2="387.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.49"
					y1="432.14"
					x2="402.49"
					y2="387.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.16"
					y1="432.14"
					x2="403.66"
					y2="432.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.16"
					y1="387.73"
					x2="403.66"
					y2="387.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.91"
					y1="429.23"
					x2="366.91"
					y2="390.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.91"
					y1="390.64"
					x2="368.08"
					y2="389.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.08"
					y1="389.47"
					x2="400.74"
					y2="389.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.74"
					y1="389.47"
					x2="401.91"
					y2="390.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="390.64"
					x2="401.91"
					y2="429.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.91"
					y1="429.23"
					x2="400.74"
					y2="430.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.74"
					y1="430.39"
					x2="368.08"
					y2="430.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.08"
					y1="430.39"
					x2="366.91"
					y2="429.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m380.61,421.04c0-3.22-2.61-5.83-5.83-5.83s-5.83,2.61-5.83,5.83,2.61,5.83,5.83,5.83,5.83-2.61,5.83-5.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m398.4,421.04c0-2.41-1.96-4.37-4.37-4.37s-4.37,1.96-4.37,4.37,1.96,4.37,4.37,4.37,4.37-1.96,4.37-4.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m379.16,398.83c0-2.41-1.96-4.37-4.37-4.37s-4.37,1.96-4.37,4.37,1.96,4.37,4.37,4.37,4.37-1.96,4.37-4.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m399.86,398.83c0-3.22-2.61-5.83-5.83-5.83s-5.83,2.61-5.83,5.83,2.61,5.83,5.83,5.83,5.83-2.61,5.83-5.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="372.38 472.8 372.38 435.93 372.72 435.1 373.54 434.76 398.23 434.76 399.06 435.1 399.4 435.93 399.4 472.8 399.06 473.63 398.23 473.97 373.54 473.97 372.72 473.63 372.38 472.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="372.38"
					y1="472.8"
					x2="372.38"
					y2="435.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m372.38,435.93c0-.65.52-1.17,1.17-1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.54"
					y1="434.76"
					x2="398.23"
					y2="434.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m398.23,434.76c.65,0,1.17.52,1.17,1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.4"
					y1="435.93"
					x2="399.4"
					y2="472.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m399.4,472.8c0,.64-.52,1.17-1.17,1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.23"
					y1="473.97"
					x2="373.54"
					y2="473.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m373.54,473.97c-.64,0-1.17-.52-1.17-1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.29"
					y1="469.89"
					x2="375.29"
					y2="438.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.46"
					y1="437.67"
					x2="392.4"
					y2="437.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.57"
					y1="438.84"
					x2="393.57"
					y2="469.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.4"
					y1="471.05"
					x2="376.46"
					y2="471.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.29"
					y1="469.89"
					x2="375.29"
					y2="469.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m375.29,438.84c0-.65.52-1.17,1.17-1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m392.4,437.67c.65,0,1.17.52,1.17,1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m393.57,469.89c0,.64-.52,1.17-1.17,1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m376.46,471.05c-.64,0-1.17-.52-1.17-1.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m389.49,454.36c0-.96-.78-1.75-1.75-1.75s-1.75.78-1.75,1.75.78,1.75,1.75,1.75,1.75-.78,1.75-1.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="386.12 454.89 385.75 454.74 385.59 454.36 385.75 453.99 386.12 453.84 397.65 453.84 398.02 453.99 398.18 454.36 398.02 454.74 397.65 454.89 386.12 454.89"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m386.12,454.89c-.29,0-.53-.23-.53-.53s.23-.52.53-.52h0"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.12"
					y1="453.84"
					x2="397.65"
					y2="453.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m397.65,453.84c.29,0,.53.23.53.52s-.23.53-.53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.65"
					y1="454.89"
					x2="386.12"
					y2="454.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="394.68 455.53 394.68 454.89 397.65 454.89 398.02 454.74 398.18 454.36 398.02 453.99 397.65 453.84 394.68 453.84 394.68 453.2 398.47 453.2 398.47 455.53 394.68 455.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="394.68"
					y1="455.53"
					x2="394.68"
					y2="454.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.68"
					y1="454.89"
					x2="397.65"
					y2="454.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m397.65,453.84c.29,0,.53.23.53.52s-.23.53-.53.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.65"
					y1="453.84"
					x2="394.68"
					y2="453.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.68"
					y1="453.84"
					x2="394.68"
					y2="453.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.68"
					y1="453.2"
					x2="398.47"
					y2="453.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.47"
					y1="453.2"
					x2="398.47"
					y2="455.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.47"
					y1="455.53"
					x2="394.68"
					y2="455.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="392.58 455.51 392.58 454.89 394.62 454.89 394.62 455.51 392.58 455.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="392.58"
					y1="455.51"
					x2="392.58"
					y2="454.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.58"
					y1="454.89"
					x2="394.62"
					y2="454.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.62"
					y1="454.89"
					x2="394.62"
					y2="455.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.62"
					y1="455.51"
					x2="392.58"
					y2="455.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="392.58 453.22 394.62 453.22 394.62 453.84 392.58 453.84 392.58 453.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="392.58"
					y1="453.22"
					x2="394.62"
					y2="453.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.62"
					y1="453.22"
					x2="394.62"
					y2="453.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.62"
					y1="453.84"
					x2="392.58"
					y2="453.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.58"
					y1="453.84"
					x2="392.58"
					y2="453.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.66"
					y1="542.47"
					x2="464.66"
					y2="552.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.66"
					y1="552.83"
					x2="436.53"
					y2="552.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.58"
					y1="542.47"
					x2="430.61"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.61"
					y1="515.82"
					x2="470.58"
					y2="515.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.58"
					y1="515.82"
					x2="470.58"
					y2="555.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.61"
					y1="555.79"
					x2="430.61"
					y2="515.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.58"
					y1="555.06"
					x2="430.61"
					y2="555.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.53"
					y1="542.47"
					x2="436.53"
					y2="552.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.58"
					y1="555.79"
					x2="430.61"
					y2="555.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.88"
					y1="371.7"
					x2="357.95"
					y2="371.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.95"
					y1="371.7"
					x2="357.95"
					y2="370.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.95"
					y1="370.22"
					x2="360.88"
					y2="370.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="373.18"
					x2="385.89"
					y2="376.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="378.71"
					x2="385.89"
					y2="382.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="384.39"
					x2="385.89"
					y2="387.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="390.08"
					x2="385.89"
					y2="393.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="395.76"
					x2="385.89"
					y2="399.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="401.45"
					x2="385.89"
					y2="405"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="407.13"
					x2="385.89"
					y2="410.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="412.82"
					x2="385.89"
					y2="416.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="418.5"
					x2="385.89"
					y2="422.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="424.19"
					x2="385.89"
					y2="427.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="429.87"
					x2="385.89"
					y2="433.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="435.55"
					x2="385.89"
					y2="439.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="441.24"
					x2="385.89"
					y2="444.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="446.93"
					x2="385.89"
					y2="450.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="452.61"
					x2="385.89"
					y2="456.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="458.3"
					x2="385.89"
					y2="461.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="463.98"
					x2="385.89"
					y2="467.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="469.67"
					x2="385.89"
					y2="473.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="475.35"
					x2="385.89"
					y2="478.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="481.04"
					x2="385.89"
					y2="484.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="486.72"
					x2="385.89"
					y2="490.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="492.41"
					x2="385.89"
					y2="495.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="498.09"
					x2="385.89"
					y2="501.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="503.78"
					x2="385.89"
					y2="507.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="509.46"
					x2="385.89"
					y2="513.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="515.15"
					x2="385.89"
					y2="518.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="520.83"
					x2="385.89"
					y2="524.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="526.52"
					x2="385.89"
					y2="530.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="532.2"
					x2="385.89"
					y2="535.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="537.89"
					x2="385.89"
					y2="541.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="543.57"
					x2="385.89"
					y2="547.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="549.26"
					x2="385.89"
					y2="552.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.89"
					y1="554.94"
					x2="385.89"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="373.18"
					x2="368.12"
					y2="387.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="325.08"
					x2="368.12"
					y2="328.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="330.3"
					x2="368.12"
					y2="333.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="335.98"
					x2="368.12"
					y2="339.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="341.67"
					x2="368.12"
					y2="345.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="347.35"
					x2="368.12"
					y2="350.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="353.04"
					x2="368.12"
					y2="356.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="358.72"
					x2="368.12"
					y2="362.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="364.41"
					x2="368.12"
					y2="367.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="370.09"
					x2="368.12"
					y2="373.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.66"
					y1="558.34"
					x2="368.12"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.88"
					y1="325.08"
					x2="580.77"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.77"
					y1="313.24"
					x2="482.88"
					y2="313.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.12"
					y1="325.08"
					x2="900.58"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.01"
					y1="313.24"
					x2="800.12"
					y2="313.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.12"
					y1="432.14"
					x2="368.12"
					y2="558.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m156.63,405.15c1.53-43.17,35.88-77.97,79.02-80.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m144.79,405.15s0-.08,0-.12c0-50.33,40.53-91.28,90.86-91.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.66"
					y1="520.26"
					x2="436.53"
					y2="520.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.53"
					y1="520.26"
					x2="436.53"
					y2="539.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.53"
					y1="539.51"
					x2="464.66"
					y2="539.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.66"
					y1="539.51"
					x2="464.66"
					y2="520.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="156.63 402.19 156.63 405.15 147.75 405.15 147.75 402.19 156.63 402.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="156.63"
					y1="402.19"
					x2="156.63"
					y2="405.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.63"
					y1="405.15"
					x2="147.75"
					y2="405.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.75"
					y1="405.15"
					x2="147.75"
					y2="402.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.75"
					y1="402.19"
					x2="156.63"
					y2="402.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="235.65 325.08 232.69 325.08 232.69 316.2 235.65 316.2 235.65 325.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="235.65"
					y1="325.08"
					x2="232.69"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.69"
					y1="325.08"
					x2="232.69"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.69"
					y1="316.2"
					x2="235.65"
					y2="316.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.65"
					y1="316.2"
					x2="235.65"
					y2="325.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="950 313.24 950 570.37 909.95 570.37 909.95 646.8 688.05 646.8 688.05 634.95 706.36 634.95 706.36 627.36 713.75 627.36 713.75 634.95 898.11 634.95 898.11 558.52 938.15 558.52 938.15 334.82 900.58 334.82 900.58 325.08 898.01 325.08 898.01 313.24 950 313.24"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
				<polygon
					points="631.79 634.95 631.79 646.8 597.09 646.8 597.09 635.64 295.29 635.64 295.29 686.76 144.87 686.76 144.87 550.44 156.71 550.44 156.71 640.02 205.87 640.02 205.87 674.92 283.45 674.92 283.45 623.81 608.93 623.81 608.93 634.95 631.79 634.95"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
				<polygon
					points="144.87 405.15 156.71 405.15 156.71 494.18 144.87 494.18 144.87 405.15 144.87 405.15"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
				<polygon
					points="574.72 538.14 574.72 545.54 546.81 545.54 546.81 558.33 534.17 558.33 534.17 550.94 539.41 550.94 539.41 513.36 480.85 513.36 480.85 550.94 486.79 550.94 486.79 558.33 472.8 558.33 472.8 550.94 473.45 550.94 473.45 513.36 427.73 513.36 427.73 550.94 428.39 550.94 428.39 558.33 403.65 558.33 403.65 373.18 412.23 373.18 412.23 325.08 314.52 325.08 314.52 334.99 274.64 334.99 274.64 325.08 235.65 325.08 235.65 313.24 482.88 313.24 482.88 325.08 463.92 325.08 463.92 384.89 456.52 384.89 456.52 372.53 419.63 372.53 419.63 505.96 456.52 505.96 456.52 492.22 463.92 492.22 463.92 505.96 546.81 505.96 546.81 538.14 574.72 538.14"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
				<polygon
					points="800.12 313.24 800.12 325.08 790.12 325.08 790.12 372.7 757.53 372.7 757.53 472.8 750.13 472.8 750.13 469.76 713.75 469.76 713.75 545.16 750.13 545.16 750.13 542.1 757.53 542.1 757.53 552.55 713.75 552.55 713.75 579.98 706.36 579.98 706.36 469.76 688 469.76 688 462.35 739.88 462.35 739.88 369.57 719.63 369.57 719.63 325.08 633.37 325.08 633.37 462.35 640.63 462.35 640.63 469.76 633.37 469.76 633.37 545.54 622.1 545.54 622.1 538.14 625.96 538.14 625.96 325.08 580.77 325.08 580.77 313.24 800.12 313.24"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
			</g>
			<g id="text">
				<path d="m384.39,353.24h-.97l-1.16-1.94c-.11-.18-.21-.33-.31-.46-.1-.13-.2-.23-.31-.31-.1-.08-.22-.14-.34-.17-.12-.04-.25-.06-.41-.06h-.67v2.94h-.81v-6.92h2.07c.3,0,.58.04.83.12.26.07.48.19.67.34.19.15.34.35.44.58.11.23.16.5.16.81,0,.24-.04.46-.11.67-.07.2-.17.38-.31.54-.13.16-.29.29-.48.41-.19.11-.4.19-.63.26v.02c.12.05.22.11.3.18.09.06.17.14.25.23.08.09.15.19.23.31.08.11.16.24.26.4l1.3,2.08Zm-4.15-6.19v2.51h1.1c.2,0,.39-.03.56-.09.17-.06.32-.15.45-.26.13-.12.22-.26.29-.42.07-.17.11-.35.11-.56,0-.37-.12-.66-.36-.86-.24-.21-.58-.31-1.04-.31h-1.11Zm8.87,3.91h-3.49c.01.55.16.97.44,1.27s.67.45,1.17.45c.56,0,1.07-.18,1.53-.55v.74c-.43.32-1.01.47-1.72.47s-1.25-.22-1.65-.67c-.4-.45-.6-1.08-.6-1.9,0-.77.22-1.39.65-1.88.44-.49.98-.73,1.63-.73s1.15.21,1.5.63.53,1,.53,1.74v.41Zm-.81-.67c0-.46-.11-.81-.33-1.07-.22-.25-.52-.38-.9-.38s-.69.13-.95.4c-.26.27-.42.62-.48,1.05h2.67Zm4.36-3.68c-.15-.09-.33-.13-.53-.13-.55,0-.83.35-.83,1.05v.76h1.16v.68h-1.16v4.27h-.79v-4.27h-.84v-.68h.84v-.8c0-.52.15-.93.45-1.23.3-.3.67-.45,1.12-.45.24,0,.43.03.57.09v.71Z" />
				<path d="m393.49,353.35c-.15,0-.28-.05-.38-.16-.1-.11-.15-.23-.15-.38s.05-.27.15-.38c.11-.11.23-.16.38-.16s.28.05.39.16c.11.11.16.23.16.38s-.05.28-.16.38c-.11.11-.23.16-.39.16Z" />
				<path d="m386.62,498.51v-6.87h2.37c.53,0,.94.03,1.22.1.39.09.73.25,1.01.49.36.31.63.7.81,1.18.18.47.27,1.02.27,1.63,0,.52-.06.98-.18,1.39-.12.4-.28.74-.47,1-.19.26-.4.47-.63.62-.22.15-.5.26-.82.34-.32.08-.69.12-1.1.12h-2.48Zm.91-.81h1.47c.45,0,.81-.04,1.06-.13.26-.08.47-.2.62-.36.22-.22.38-.5.5-.87.12-.37.18-.81.18-1.33,0-.72-.12-1.27-.36-1.65-.23-.39-.52-.65-.86-.78-.24-.09-.64-.14-1.18-.14h-1.44v5.25Zm7.22.81l-1.82-6.87h.93l1.05,4.5c.11.47.21.94.29,1.41.17-.73.28-1.16.31-1.27l1.31-4.64h1.1l.98,3.48c.25.86.42,1.67.53,2.43.09-.43.2-.93.34-1.5l1.08-4.42h.91l-1.88,6.87h-.88l-1.45-5.24c-.12-.44-.19-.71-.22-.81-.07.32-.14.58-.2.81l-1.46,5.24h-.93Z" />
				<path d="m202.31,495.01h-5.57v-10.73h1.26v9.59h4.31v1.14Zm2.11-9.61c-.22,0-.41-.07-.56-.22-.15-.15-.23-.34-.23-.57s.08-.42.23-.57c.15-.15.34-.23.56-.23s.41.08.57.23c.16.15.24.34.24.57s-.08.41-.24.56c-.15.15-.34.23-.57.23Zm.6,9.61h-1.23v-7.66h1.23v7.66Zm8.5-7.66l-3.05,7.66h-1.2l-2.9-7.66h1.35l1.95,5.57c.14.41.23.77.27,1.07h.03c.05-.38.13-.73.24-1.04l2.03-5.6h1.29Zm1.94-1.95c-.22,0-.41-.07-.56-.22-.15-.15-.23-.34-.23-.57s.08-.42.23-.57c.15-.15.34-.23.56-.23s.41.08.57.23c.16.15.24.34.24.57s-.08.41-.24.56c-.15.15-.34.23-.57.23Zm.6,9.61h-1.23v-7.66h1.23v7.66Zm8.84,0h-1.23v-4.37c0-1.63-.59-2.44-1.78-2.44-.61,0-1.12.23-1.53.7-.4.46-.6,1.04-.6,1.74v4.37h-1.23v-7.66h1.23v1.27h.03c.58-.97,1.42-1.45,2.51-1.45.84,0,1.48.27,1.92.82.44.54.67,1.32.67,2.34v4.68Zm8.85-.61c0,2.81-1.35,4.22-4.04,4.22-.95,0-1.78-.18-2.48-.54v-1.23c.86.48,1.69.72,2.47.72,1.89,0,2.83-1,2.83-3.01v-.84h-.03c-.58.98-1.46,1.47-2.63,1.47-.95,0-1.72-.34-2.3-1.02-.58-.68-.87-1.6-.87-2.75,0-1.3.31-2.34.94-3.1.63-.77,1.49-1.15,2.57-1.15s1.8.41,2.3,1.24h.03v-1.06h1.23v7.05Zm-1.23-2.85v-1.13c0-.61-.21-1.13-.62-1.56-.41-.43-.92-.65-1.53-.65-.76,0-1.35.28-1.78.83-.43.55-.64,1.32-.64,2.31,0,.85.2,1.54.61,2.05.41.51.96.76,1.64.76s1.25-.24,1.68-.73c.43-.49.65-1.11.65-1.88Z" />
				<polygon points="241.06 484.29 235.92 496.79 234.77 496.79 239.9 484.29 241.06 484.29" />
				<path d="m242.31,495.01v-10.73h2.96c3.78,0,5.67,1.74,5.67,5.23,0,1.66-.53,2.99-1.58,4-1.05,1-2.45,1.5-4.21,1.5h-2.84Zm1.26-9.59v8.45h1.6c1.41,0,2.5-.38,3.28-1.13.78-.75,1.17-1.82,1.17-3.2,0-2.75-1.46-4.12-4.38-4.12h-1.68Zm9.94-.02c-.22,0-.41-.07-.56-.22-.15-.15-.23-.34-.23-.57s.08-.42.23-.57c.15-.15.34-.23.56-.23s.41.08.57.23c.16.15.24.34.24.57s-.08.41-.24.56c-.15.15-.34.23-.57.23Zm.6,9.61h-1.23v-7.66h1.23v7.66Zm8.83,0h-1.23v-4.37c0-1.63-.59-2.44-1.78-2.44-.61,0-1.12.23-1.53.7-.4.46-.6,1.04-.6,1.74v4.37h-1.23v-7.66h1.23v1.27h.03c.58-.97,1.42-1.45,2.51-1.45.84,0,1.48.27,1.92.82.44.54.67,1.32.67,2.34v4.68Zm2.93-9.61c-.22,0-.41-.07-.56-.22-.15-.15-.23-.34-.23-.57s.08-.42.23-.57c.15-.15.34-.23.56-.23s.41.08.57.23c.16.15.24.34.24.57s-.08.41-.24.56c-.15.15-.34.23-.57.23Zm.6,9.61h-1.23v-7.66h1.23v7.66Zm8.83,0h-1.23v-4.37c0-1.63-.59-2.44-1.78-2.44-.61,0-1.12.23-1.53.7-.4.46-.6,1.04-.6,1.74v4.37h-1.23v-7.66h1.23v1.27h.03c.58-.97,1.42-1.45,2.51-1.45.84,0,1.48.27,1.92.82.44.54.67,1.32.67,2.34v4.68Zm8.84-.61c0,2.81-1.35,4.22-4.04,4.22-.95,0-1.78-.18-2.48-.54v-1.23c.86.48,1.69.72,2.47.72,1.89,0,2.83-1,2.83-3.01v-.84h-.03c-.58.98-1.46,1.47-2.63,1.47-.95,0-1.72-.34-2.3-1.02-.58-.68-.87-1.6-.87-2.75,0-1.3.31-2.34.94-3.1.63-.77,1.49-1.15,2.57-1.15s1.8.41,2.3,1.24h.03v-1.06h1.23v7.05Zm-1.23-2.85v-1.13c0-.61-.21-1.13-.62-1.56-.41-.43-.92-.65-1.53-.65-.76,0-1.35.28-1.78.83-.43.55-.64,1.32-.64,2.31,0,.85.2,1.54.61,2.05.41.51.96.76,1.64.76s1.25-.24,1.68-.73c.43-.49.65-1.11.65-1.88Z" />
				<path d="m298.64,495.01h-1.5l-1.8-3.01c-.16-.28-.32-.52-.48-.71-.15-.2-.31-.36-.48-.49-.16-.12-.33-.21-.52-.27-.18-.06-.39-.09-.63-.09h-1.03v4.56h-1.26v-10.73h3.2c.47,0,.9.06,1.29.18.4.11.74.29,1.03.53.29.24.52.54.69.9.16.35.25.77.25,1.25,0,.37-.06.72-.17,1.03-.11.31-.27.59-.48.83-.2.24-.45.45-.75.63-.29.17-.62.3-.98.4v.03c.18.08.33.17.46.28.13.1.26.22.38.36.12.14.24.3.35.48.12.17.25.38.4.61l2.01,3.22Zm-6.43-9.59v3.89h1.71c.31,0,.6-.05.87-.14.27-.09.5-.23.7-.4.19-.18.35-.4.46-.65.11-.26.16-.55.16-.87,0-.57-.19-1.02-.56-1.34-.37-.32-.91-.49-1.61-.49h-1.72Zm10.85,9.77c-1.13,0-2.04-.36-2.72-1.07-.67-.72-1.01-1.67-1.01-2.85,0-1.29.35-2.29,1.05-3.02.7-.72,1.65-1.08,2.85-1.08s2.03.35,2.67,1.05c.64.7.97,1.68.97,2.93s-.35,2.2-1.04,2.94c-.69.73-1.61,1.1-2.78,1.1Zm.09-6.99c-.79,0-1.41.27-1.87.81-.46.53-.69,1.27-.69,2.21s.23,1.62.7,2.15c.46.52,1.08.79,1.86.79s1.4-.26,1.83-.77c.43-.51.64-1.24.64-2.19s-.21-1.7-.64-2.21c-.42-.52-1.03-.78-1.83-.78Zm8.8,6.99c-1.13,0-2.04-.36-2.72-1.07-.67-.72-1.01-1.67-1.01-2.85,0-1.29.35-2.29,1.05-3.02.7-.72,1.65-1.08,2.85-1.08s2.03.35,2.67,1.05c.64.7.97,1.68.97,2.93s-.35,2.2-1.04,2.94c-.69.73-1.61,1.1-2.78,1.1Zm.09-6.99c-.79,0-1.41.27-1.87.81-.46.53-.69,1.27-.69,2.21s.23,1.62.7,2.15c.46.52,1.08.79,1.86.79s1.4-.26,1.83-.77c.43-.51.64-1.24.64-2.19s-.21-1.7-.64-2.21c-.42-.52-1.03-.78-1.83-.78h0Zm16.47,6.81h-1.23v-4.4c0-.85-.13-1.46-.4-1.84-.26-.38-.7-.57-1.32-.57-.52,0-.97.24-1.34.72-.36.48-.55,1.05-.55,1.72v4.37h-1.23v-4.55c0-1.51-.58-2.26-1.74-2.26-.54,0-.98.23-1.33.68-.35.45-.52,1.03-.52,1.76v4.37h-1.23v-7.66h1.23v1.21h.03c.54-.93,1.34-1.39,2.38-1.39.52,0,.98.15,1.37.44.39.29.66.67.8,1.14.57-1.06,1.42-1.59,2.54-1.59,1.69,0,2.53,1.04,2.53,3.12v4.72Z" />
				<path d="m232.77,510.92h-.89v-6.74c-.07.07-.17.15-.3.24-.13.09-.28.17-.45.26-.16.09-.34.17-.52.24-.18.08-.36.14-.53.18v-.9c.2-.05.4-.13.62-.22.22-.09.44-.2.65-.31.21-.12.42-.24.6-.36.19-.13.35-.25.49-.37h.34v7.98Zm6.02,0h-.89v-6.74c-.07.07-.17.15-.3.24-.13.09-.28.17-.45.26-.16.09-.34.17-.52.24-.18.08-.36.14-.53.18v-.9c.2-.05.4-.13.62-.22.22-.09.44-.2.65-.31.21-.12.42-.24.6-.36.19-.13.35-.25.49-.37h.34v7.98Z" />
				<rect x="241.75" y="503.12" width=".79" height="2.43" />
				<path d="m247.33,510.92h-.89v-6.74c-.07.07-.17.15-.3.24-.13.09-.28.17-.45.26-.16.09-.34.17-.52.24-.18.08-.36.14-.53.18v-.9c.2-.05.4-.13.62-.22.22-.09.44-.2.65-.31.21-.12.42-.24.6-.36.19-.13.35-.25.49-.37h.34v7.98Zm7.63-3.93c0,.65-.06,1.23-.18,1.74-.12.5-.29.93-.51,1.28-.22.34-.5.61-.82.79-.32.18-.69.27-1.1.27-.39,0-.74-.09-1.05-.26-.3-.17-.56-.43-.77-.76-.21-.33-.37-.73-.48-1.21-.11-.48-.16-1.03-.16-1.65,0-.68.06-1.28.17-1.81.12-.52.28-.96.51-1.31.22-.36.5-.62.82-.8.33-.18.71-.27,1.13-.27,1.64,0,2.45,1.33,2.45,4Zm-.91.09c0-2.22-.53-3.33-1.58-3.33-1.11,0-1.67,1.13-1.67,3.39,0,2.11.55,3.16,1.64,3.16s1.62-1.07,1.62-3.22Z" />
				<path d="m257.11,503.12v2.43h-.79v-2.43h.79Zm1.81,0v2.43h-.79v-2.43h.79Z" />
				<path d="m267.84,505.35l-1.87,2.82,1.84,2.75h-1.04l-1.09-1.81c-.07-.11-.15-.25-.24-.42h-.02s-.1.17-.26.42l-1.12,1.81h-1.03l1.9-2.73-1.82-2.84h1.04l1.08,1.9c.08.14.16.29.23.44h.02l1.39-2.34h.99Z" />
				<path d="m274.98,510.92h-.89v-6.74c-.07.07-.17.15-.3.24-.13.09-.28.17-.45.26-.16.09-.34.17-.52.24-.18.08-.36.14-.53.18v-.9c.2-.05.4-.13.62-.22.22-.09.44-.2.65-.31.21-.12.42-.24.6-.36.19-.13.35-.25.49-.37h.34v7.98Zm7.54-4.37c0,.71-.07,1.35-.21,1.91-.14.56-.35,1.03-.62,1.42-.27.38-.6.68-1,.88-.39.2-.84.3-1.34.3s-.97-.09-1.36-.27v-.85c.43.24.89.36,1.38.36.35,0,.67-.07.94-.22.28-.15.52-.36.71-.63.19-.28.34-.62.44-1.03s.15-.87.15-1.4h-.02c-.33.67-.91,1.01-1.74,1.01-.33,0-.64-.06-.92-.17-.28-.12-.52-.29-.72-.5-.2-.22-.36-.48-.47-.77-.11-.3-.17-.63-.17-.99,0-.38.06-.74.19-1.06.13-.32.3-.59.52-.82.22-.23.49-.41.79-.54.31-.13.64-.19,1.01-.19.39,0,.74.08,1.04.24.3.16.56.39.77.69.21.3.36.67.47,1.12.11.44.16.95.16,1.52Zm-.96-.8c0-.3-.04-.58-.12-.82-.08-.25-.18-.46-.32-.63-.14-.18-.3-.31-.5-.41-.19-.1-.4-.15-.62-.15s-.41.04-.6.13c-.19.08-.35.2-.48.36-.13.15-.24.34-.32.55-.08.21-.11.44-.11.69,0,.28.04.52.11.74.08.22.18.4.32.56.14.15.3.26.5.34.2.08.41.12.65.12.21,0,.4-.04.58-.11.19-.08.34-.19.48-.32.14-.13.24-.29.32-.47.08-.18.12-.38.12-.58Z" />
				<rect x="283.96" y="503.12" width=".79" height="2.43" />
				<path d="m291.1,503.63c-.12.21-.26.46-.44.77-.17.31-.34.65-.53,1.04-.19.38-.38.8-.58,1.24-.2.44-.38.9-.55,1.37-.17.47-.32.95-.45,1.44-.13.48-.22.96-.28,1.43h-.96c.07-.46.17-.94.3-1.42.14-.49.29-.96.46-1.43.17-.47.36-.92.55-1.35.19-.43.38-.83.56-1.19.18-.36.35-.68.5-.96.15-.28.27-.5.36-.65h-3.91v-.81h4.96v.52Z" />
				<path d="m293.3,503.12v2.43h-.79v-2.43h.79Zm1.81,0v2.43h-.79v-2.43h.79Z" />
				<path d="m809.9,478.97v-10.73h3.05c.93,0,1.66.23,2.21.68.54.45.82,1.04.82,1.77,0,.61-.16,1.14-.49,1.59-.33.45-.78.77-1.36.96v.03c.72.08,1.3.36,1.74.82.43.46.65,1.06.65,1.8,0,.92-.33,1.66-.99,2.23-.66.57-1.49.85-2.49.85h-3.13Zm1.26-9.59v3.46h1.29c.69,0,1.23-.16,1.62-.49.39-.33.59-.8.59-1.41,0-1.04-.69-1.56-2.06-1.56h-1.44Zm0,4.59v3.86h1.71c.74,0,1.31-.17,1.71-.52.41-.35.61-.83.61-1.44,0-1.27-.86-1.9-2.59-1.9h-1.44Zm13.51,1.47h-5.41c.02.85.25,1.51.69,1.98.44.46,1.04.7,1.81.7.86,0,1.66-.28,2.38-.85v1.15c-.67.49-1.56.73-2.67.73s-1.93-.35-2.55-1.04c-.62-.7-.93-1.68-.93-2.94,0-1.19.34-2.16,1.01-2.91.68-.75,1.52-1.13,2.52-1.13s1.78.32,2.33.97c.55.65.82,1.55.82,2.7v.64Zm-1.26-1.04c0-.71-.18-1.26-.52-1.65-.33-.39-.8-.59-1.4-.59s-1.07.21-1.47.62c-.4.41-.65.96-.75,1.62h4.14Zm9.64,4.56h-1.23v-1.3h-.03c-.57.99-1.45,1.48-2.63,1.48-.96,0-1.73-.34-2.31-1.03-.57-.69-.86-1.62-.86-2.81,0-1.27.32-2.28.96-3.04s1.49-1.14,2.55-1.14,1.82.41,2.3,1.24h.03v-4.74h1.23v11.34Zm-1.23-3.46v-1.13c0-.62-.2-1.14-.61-1.57-.41-.43-.93-.64-1.56-.64-.75,0-1.34.27-1.77.82-.43.55-.64,1.31-.64,2.27,0,.88.2,1.58.61,2.09.41.51.97.76,1.66.76s1.24-.25,1.66-.74c.43-.49.64-1.12.64-1.87Zm7.7-2.96c-.21-.16-.52-.25-.93-.25-.52,0-.96.25-1.32.74-.35.49-.52,1.17-.52,2.02v3.91h-1.23v-7.66h1.23v1.58h.03c.17-.54.44-.96.8-1.26.36-.3.76-.46,1.2-.46.32,0,.56.03.73.1v1.27Zm4.53,6.6c-1.13,0-2.04-.36-2.72-1.07-.67-.72-1.01-1.67-1.01-2.85,0-1.29.35-2.29,1.05-3.02.7-.72,1.65-1.08,2.85-1.08s2.03.35,2.67,1.05c.64.7.97,1.68.97,2.93s-.35,2.2-1.04,2.94c-.69.73-1.61,1.1-2.78,1.1Zm.09-6.99c-.79,0-1.41.27-1.87.81-.46.53-.69,1.27-.69,2.21s.23,1.62.7,2.15c.46.52,1.08.79,1.86.79s1.4-.26,1.83-.77c.43-.51.64-1.24.64-2.19s-.21-1.7-.64-2.21c-.42-.52-1.03-.78-1.83-.78Zm8.88,6.99c-1.13,0-2.04-.36-2.72-1.07-.67-.72-1.01-1.67-1.01-2.85,0-1.29.35-2.29,1.05-3.02.7-.72,1.65-1.08,2.85-1.08s2.03.35,2.67,1.05c.64.7.97,1.68.97,2.93s-.35,2.2-1.04,2.94c-.69.73-1.61,1.1-2.78,1.1Zm.09-6.99c-.79,0-1.41.27-1.87.81-.46.53-.69,1.27-.69,2.21s.23,1.62.7,2.15c.46.52,1.08.79,1.86.79s1.4-.26,1.83-.77c.43-.51.64-1.24.64-2.19s-.21-1.7-.64-2.21c-.42-.52-1.03-.78-1.83-.78h0Zm16.56,6.81h-1.23v-4.4c0-.85-.13-1.46-.4-1.84-.26-.38-.7-.57-1.32-.57-.52,0-.97.24-1.34.72-.36.48-.55,1.05-.55,1.72v4.37h-1.23v-4.55c0-1.51-.58-2.26-1.74-2.26-.54,0-.98.23-1.33.68-.35.45-.52,1.03-.52,1.76v4.37h-1.23v-7.66h1.23v1.21h.03c.54-.93,1.34-1.39,2.38-1.39.52,0,.98.15,1.37.44.39.29.66.67.8,1.14.57-1.06,1.42-1.59,2.54-1.59,1.69,0,2.53,1.04,2.53,3.12v4.72Z" />
				<path d="m880.33,478.97h-1.23v-9.27c-.09.09-.23.2-.42.33-.18.12-.38.24-.61.36-.22.12-.46.23-.72.34-.25.1-.49.19-.73.25v-1.24c.27-.07.55-.17.85-.3.3-.13.6-.27.89-.43.29-.16.57-.32.83-.49.26-.17.48-.34.67-.51h.46v10.97Z" />
				<path d="m819.2,494.88h-.89v-6.74c-.07.07-.17.15-.3.24-.13.09-.28.17-.45.26-.16.09-.34.17-.52.24-.18.08-.36.14-.53.18v-.9c.2-.05.4-.13.62-.22.22-.09.44-.2.65-.31.21-.12.42-.24.6-.36.19-.13.35-.25.49-.37h.34v7.98Zm7.63-3.94c0,.65-.06,1.23-.18,1.74-.12.5-.29.93-.51,1.28-.22.34-.5.61-.82.79-.32.18-.69.27-1.1.27-.39,0-.74-.09-1.05-.26-.3-.17-.56-.43-.77-.76-.21-.33-.37-.73-.48-1.21-.11-.48-.16-1.03-.16-1.65,0-.68.06-1.28.17-1.81.12-.52.28-.96.51-1.31.22-.36.5-.62.82-.8.33-.18.71-.27,1.13-.27,1.64,0,2.45,1.33,2.45,4Zm-.91.09c0-2.22-.53-3.33-1.58-3.33-1.11,0-1.67,1.13-1.67,3.39,0,2.11.55,3.16,1.64,3.16s1.62-1.07,1.62-3.22Z" />
				<rect x="828.18" y="487.08" width=".79" height="2.43" />
				<path d="m835.38,490.95c0,.65-.06,1.23-.18,1.74-.12.5-.29.93-.51,1.28-.22.34-.5.61-.82.79-.32.18-.69.27-1.1.27-.39,0-.74-.09-1.05-.26-.3-.17-.56-.43-.77-.76-.21-.33-.37-.73-.48-1.21-.11-.48-.16-1.03-.16-1.65,0-.68.06-1.28.17-1.81.12-.52.28-.96.51-1.31.22-.36.5-.62.82-.8.33-.18.71-.27,1.13-.27,1.64,0,2.45,1.33,2.45,4Zm-.91.09c0-2.22-.53-3.33-1.58-3.33-1.11,0-1.67,1.13-1.67,3.39,0,2.11.55,3.16,1.64,3.16s1.62-1.07,1.62-3.22Z" />
				<path d="m837.52,487.08v2.43h-.79v-2.43h.79Zm1.81,0v2.43h-.79v-2.43h.79Z" />
				<path d="m848.25,489.31l-1.87,2.82,1.84,2.75h-1.04l-1.09-1.81c-.07-.11-.15-.25-.24-.42h-.02s-.1.17-.26.42l-1.12,1.81h-1.03l1.9-2.73-1.82-2.84h1.04l1.08,1.9c.08.14.16.29.23.44h.02l1.39-2.34h.99Z" />
				<path d="m855.39,494.88h-.89v-6.74c-.07.07-.17.15-.3.24-.13.09-.28.17-.45.26-.16.09-.34.17-.52.24-.18.08-.36.14-.53.18v-.9c.2-.05.4-.13.62-.22.22-.09.44-.2.65-.31.21-.12.42-.24.6-.36.19-.13.35-.25.49-.37h.34v7.98Zm7.58-7.29c-.12.21-.26.46-.44.77-.17.31-.34.65-.53,1.04-.19.38-.38.8-.58,1.24-.2.44-.38.9-.55,1.37-.17.47-.32.95-.45,1.44-.13.48-.22.96-.28,1.43h-.96c.07-.46.17-.94.3-1.42.14-.49.29-.96.46-1.43.17-.47.36-.92.55-1.35.19-.43.38-.83.56-1.19.18-.36.35-.68.5-.96.15-.28.27-.5.36-.65h-3.91v-.81h4.96v.52Z" />
				<rect x="864.38" y="487.08" width=".79" height="2.43" />
				<path d="m870.64,487.08v5.15h1v.82h-1v1.83h-.88v-1.83h-3.67v-.77c.34-.38.69-.79,1.03-1.23.35-.44.68-.88,1-1.33.32-.45.61-.9.88-1.34.27-.45.5-.88.69-1.29h.95Zm-3.54,5.15h2.66v-3.82c-.27.48-.53.9-.77,1.27-.24.37-.48.71-.7,1.02-.22.3-.43.58-.63.83-.2.25-.39.48-.57.7Z" />
				<path d="m873.71,487.08v2.43h-.79v-2.43h.79Zm1.81,0v2.43h-.79v-2.43h.79Z" />
				<path d="m509,414.48v-10.73h3.05c.93,0,1.66.23,2.21.68.54.45.82,1.05.82,1.77,0,.61-.16,1.14-.49,1.59-.33.45-.78.77-1.36.96v.03c.72.08,1.3.36,1.74.82.43.46.65,1.06.65,1.8,0,.92-.33,1.66-.99,2.23-.66.57-1.49.85-2.49.85h-3.13Zm1.26-9.59v3.46h1.29c.69,0,1.23-.16,1.62-.49.39-.33.59-.8.59-1.41,0-1.04-.69-1.56-2.06-1.56h-1.44Zm0,4.59v3.86h1.71c.74,0,1.31-.17,1.71-.52.41-.35.61-.83.61-1.44,0-1.27-.86-1.9-2.59-1.9h-1.44Zm13.51,1.47h-5.41c.02.85.25,1.51.69,1.98.44.46,1.04.7,1.81.7.86,0,1.66-.28,2.38-.85v1.15c-.67.49-1.56.73-2.67.73s-1.93-.35-2.55-1.04c-.62-.7-.93-1.68-.93-2.94,0-1.19.34-2.16,1.01-2.91.68-.75,1.52-1.13,2.52-1.13s1.78.32,2.33.97c.55.65.82,1.55.82,2.7v.64Zm-1.26-1.04c0-.71-.18-1.26-.52-1.65-.33-.39-.8-.59-1.4-.59s-1.07.21-1.47.62c-.4.41-.65.96-.75,1.62h4.14Zm9.64,4.56h-1.23v-1.3h-.03c-.57.99-1.45,1.48-2.63,1.48-.96,0-1.73-.34-2.31-1.03-.57-.69-.86-1.62-.86-2.81,0-1.27.32-2.28.96-3.04.64-.76,1.49-1.14,2.55-1.14s1.82.41,2.3,1.24h.03v-4.74h1.23v11.34Zm-1.23-3.46v-1.13c0-.62-.2-1.14-.61-1.57-.41-.43-.93-.64-1.56-.64-.75,0-1.34.27-1.77.82-.43.55-.64,1.31-.64,2.27,0,.88.2,1.58.61,2.09.41.51.97.76,1.66.76s1.24-.25,1.66-.74c.43-.49.64-1.12.64-1.87Zm7.7-2.96c-.21-.16-.52-.25-.93-.25-.52,0-.96.25-1.32.74-.35.49-.52,1.17-.52,2.02v3.91h-1.23v-7.66h1.23v1.58h.03c.17-.54.44-.96.8-1.26.36-.3.76-.46,1.2-.46.32,0,.56.03.73.1v1.27Zm4.53,6.6c-1.13,0-2.04-.36-2.72-1.07-.67-.72-1.01-1.67-1.01-2.85,0-1.29.35-2.29,1.05-3.02.7-.72,1.65-1.08,2.85-1.08s2.03.35,2.67,1.05c.64.7.97,1.68.97,2.93s-.35,2.2-1.04,2.94c-.69.73-1.61,1.1-2.78,1.1Zm.09-6.99c-.79,0-1.41.27-1.87.81-.46.53-.69,1.27-.69,2.21s.23,1.62.7,2.15,1.08.79,1.86.79,1.4-.26,1.83-.77c.43-.51.64-1.24.64-2.19s-.21-1.7-.64-2.21c-.42-.52-1.03-.78-1.83-.78Zm8.88,6.99c-1.13,0-2.04-.36-2.72-1.07-.67-.72-1.01-1.67-1.01-2.85,0-1.29.35-2.29,1.05-3.02.7-.72,1.65-1.08,2.85-1.08s2.03.35,2.67,1.05c.64.7.97,1.68.97,2.93s-.35,2.2-1.04,2.94c-.69.73-1.61,1.1-2.78,1.1Zm.09-6.99c-.79,0-1.41.27-1.87.81-.46.53-.69,1.27-.69,2.21s.23,1.62.7,2.15c.46.52,1.08.79,1.86.79s1.4-.26,1.83-.77c.43-.51.64-1.24.64-2.19s-.21-1.7-.64-2.21c-.42-.52-1.03-.78-1.83-.78Zm16.56,6.81h-1.23v-4.4c0-.85-.13-1.46-.4-1.84-.26-.38-.7-.57-1.32-.57-.52,0-.97.24-1.34.72-.36.48-.55,1.05-.55,1.72v4.37h-1.23v-4.55c0-1.51-.58-2.26-1.74-2.26-.54,0-.98.23-1.33.68-.35.45-.52,1.03-.52,1.76v4.37h-1.23v-7.66h1.23v1.21h.03c.54-.93,1.34-1.39,2.38-1.39.52,0,.98.15,1.37.44.39.29.66.67.8,1.14.57-1.06,1.42-1.59,2.54-1.59,1.69,0,2.53,1.04,2.53,3.12v4.72Z" />
				<path d="m579.79,406.56c0-.33-.05-.62-.16-.86-.1-.24-.24-.45-.42-.61-.17-.16-.38-.29-.62-.37-.24-.08-.5-.12-.78-.12-.24,0-.47.03-.7.1-.23.06-.45.15-.67.27-.21.11-.42.25-.63.41-.2.16-.39.34-.56.53v-1.32c.34-.33.73-.59,1.15-.76.43-.18.95-.27,1.56-.27.44,0,.85.06,1.22.19.37.12.7.31.97.55.27.24.49.55.64.91.16.36.24.77.24,1.23,0,.42-.05.81-.15,1.15-.09.34-.24.67-.44.97-.19.3-.44.6-.74.88-.3.28-.65.56-1.05.85-.5.36-.92.67-1.25.92-.32.25-.58.49-.78.72-.19.22-.32.44-.4.67-.07.22-.11.47-.11.76h5.34v1.1h-6.62v-.53c0-.46.05-.86.15-1.21s.26-.68.49-1,.53-.63.9-.94c.37-.31.83-.67,1.37-1.06.39-.28.71-.55.97-.8.26-.25.48-.51.64-.76.16-.25.27-.51.34-.77.07-.26.1-.54.1-.84Z" />
				<path d="m522.84,426.01c0,.71-.07,1.35-.21,1.91-.14.56-.35,1.03-.62,1.42-.27.38-.6.68-1,.88-.39.2-.84.3-1.34.3s-.97-.09-1.36-.27v-.85c.43.24.89.36,1.38.36.35,0,.67-.07.94-.22.28-.15.52-.36.71-.63.19-.28.34-.62.44-1.03.1-.41.15-.87.15-1.4h-.02c-.33.67-.91,1.01-1.74,1.01-.33,0-.64-.06-.92-.17-.28-.12-.52-.29-.72-.5-.2-.22-.36-.48-.47-.77-.11-.3-.17-.63-.17-.99,0-.38.06-.74.19-1.06.13-.32.3-.59.52-.82.22-.23.49-.41.79-.54.31-.13.64-.19,1.01-.19.39,0,.74.08,1.04.24.3.16.56.39.77.69.21.3.36.67.47,1.12.11.44.16.95.16,1.52Zm-.96-.8c0-.3-.04-.58-.12-.82-.08-.25-.18-.46-.32-.63-.14-.18-.3-.31-.5-.41-.19-.1-.4-.15-.62-.15s-.41.04-.6.13c-.19.08-.35.2-.48.36-.13.15-.24.34-.32.55-.08.21-.11.44-.11.69,0,.28.04.52.11.74.08.22.18.4.32.56.14.15.3.26.5.34.2.08.41.12.65.12.21,0,.4-.04.58-.11.19-.08.34-.19.48-.32.14-.13.24-.29.32-.47.08-.18.12-.38.12-.58Z" />
				<rect x="524.28" y="422.58" width=".79" height="2.43" />
				<path d="m531.47,426.45c0,.65-.06,1.23-.18,1.74-.12.5-.29.93-.51,1.28-.22.34-.5.61-.82.79-.32.18-.69.27-1.1.27-.39,0-.74-.09-1.05-.26-.3-.17-.56-.43-.77-.76-.21-.33-.37-.73-.48-1.21-.11-.48-.16-1.03-.16-1.65,0-.68.06-1.28.17-1.81.12-.52.28-.96.51-1.31.22-.36.5-.62.82-.8.33-.18.71-.27,1.13-.27,1.64,0,2.45,1.33,2.45,4Zm-.91.09c0-2.22-.53-3.33-1.58-3.33-1.11,0-1.67,1.13-1.67,3.39,0,2.11.55,3.16,1.64,3.16s1.62-1.07,1.62-3.22Z" />
				<path d="m533.61,422.58v2.43h-.79v-2.43h.79Zm1.81,0v2.43h-.79v-2.43h.79Z" />
				<path d="m544.34,424.81l-1.87,2.82,1.84,2.75h-1.04l-1.09-1.81c-.07-.11-.15-.25-.24-.42h-.02s-.1.17-.26.42l-1.12,1.81h-1.03l1.9-2.73-1.82-2.84h1.04l1.08,1.9c.08.14.16.29.23.44h.02l1.39-2.34h.99Z" />
				<path d="m551.48,430.39h-.89v-6.74c-.07.07-.17.15-.3.24-.13.09-.28.17-.45.26-.16.09-.34.17-.52.24-.18.08-.36.14-.53.18v-.9c.2-.05.4-.13.62-.22.22-.09.44-.2.65-.31.21-.12.42-.24.6-.36.19-.13.35-.25.49-.37h.34v7.98Zm7.63-3.93c0,.65-.06,1.23-.18,1.74-.12.5-.29.93-.51,1.28-.22.34-.5.61-.82.79-.32.18-.69.27-1.1.27-.39,0-.74-.09-1.05-.26-.3-.17-.56-.43-.77-.76-.21-.33-.37-.73-.48-1.21-.11-.48-.16-1.03-.16-1.65,0-.68.06-1.28.17-1.81.12-.52.28-.96.51-1.31.22-.36.5-.62.82-.8.33-.18.71-.27,1.13-.27,1.64,0,2.45,1.33,2.45,4Zm-.91.09c0-2.22-.53-3.33-1.58-3.33-1.11,0-1.67,1.13-1.67,3.39,0,2.11.55,3.16,1.64,3.16s1.62-1.07,1.62-3.22Z" />
				<rect x="560.47" y="422.58" width=".79" height="2.43" />
				<path d="m566.31,424.63c0-.24-.04-.45-.11-.63-.07-.18-.17-.32-.3-.44-.13-.12-.28-.21-.45-.27-.17-.06-.36-.09-.57-.09-.17,0-.34.02-.51.07-.17.05-.33.11-.49.2-.16.08-.31.18-.46.3-.15.12-.28.24-.41.39v-.96c.25-.24.53-.43.84-.56.31-.13.69-.2,1.14-.2.32,0,.62.05.89.14.27.09.51.22.71.4.2.18.36.4.47.66.12.26.17.56.17.9,0,.31-.04.59-.11.84-.07.25-.18.49-.32.71-.14.22-.32.43-.54.64-.22.2-.47.41-.77.62-.37.26-.67.48-.91.67-.24.19-.42.36-.57.52-.14.16-.24.32-.29.48-.05.16-.08.34-.08.56h3.89v.8h-4.82v-.39c0-.33.04-.63.11-.88s.19-.5.36-.72c.17-.23.38-.46.65-.69.27-.23.6-.49,1-.77.28-.2.52-.4.71-.58.19-.19.35-.37.46-.56s.2-.37.24-.56c.05-.19.08-.4.08-.61Z" />
				<path d="m569.8,422.58v2.43h-.79v-2.43h.79Zm1.81,0v2.43h-.79v-2.43h.79Z" />
				<path d="m318.99,416.32h-1.75l-4.14-4.91c-.15-.18-.25-.31-.28-.37h-.03v5.28h-1.26v-10.73h1.26v5.04h.03c.07-.11.16-.23.28-.37l4.01-4.68h1.56l-4.6,5.15,4.92,5.58Zm1.88-9.61c-.22,0-.41-.07-.56-.22-.15-.15-.23-.34-.23-.57s.08-.42.23-.57c.15-.15.34-.23.56-.23s.41.08.57.23c.16.15.24.34.24.57s-.08.41-.24.56c-.15.15-.34.23-.57.23Zm.6,9.61h-1.23v-7.66h1.23v7.66Zm6.03-.07c-.29.16-.67.24-1.14.24-1.34,0-2.01-.75-2.01-2.24v-4.53h-1.32v-1.05h1.32v-1.87l1.23-.4v2.27h1.93v1.05h-1.93v4.32c0,.51.09.88.26,1.1.17.22.46.33.87.33.31,0,.58-.08.8-.25v1.05Zm6.85-.28c-.59.35-1.29.53-2.09.53-1.09,0-1.98-.35-2.65-1.06-.67-.71-1-1.64-1-2.77,0-1.26.36-2.27,1.08-3.04.72-.77,1.69-1.15,2.9-1.15.67,0,1.27.12,1.78.37v1.26c-.57-.4-1.18-.6-1.83-.6-.78,0-1.43.28-1.93.85-.5.56-.75,1.29-.75,2.21s.23,1.61.7,2.12c.47.52,1.11.78,1.9.78.67,0,1.3-.22,1.89-.67v1.17Zm8.21.35h-1.23v-4.41c0-1.6-.59-2.39-1.78-2.39-.6,0-1.1.23-1.51.7-.41.46-.61,1.05-.61,1.77v4.34h-1.23v-11.34h1.23v4.95h.03c.59-.97,1.43-1.45,2.51-1.45,1.73,0,2.59,1.04,2.59,3.12v4.72Zm8.46-3.52h-5.41c.02.85.25,1.51.69,1.98.44.46,1.04.7,1.81.7.86,0,1.66-.28,2.38-.85v1.15c-.67.49-1.56.73-2.67.73s-1.93-.35-2.55-1.04c-.62-.7-.93-1.68-.93-2.94,0-1.19.34-2.16,1.01-2.91.68-.75,1.52-1.13,2.52-1.13s1.78.32,2.33.97c.55.65.82,1.55.82,2.7v.64Zm-1.26-1.04c0-.71-.18-1.26-.52-1.65-.33-.39-.8-.59-1.4-.59s-1.07.21-1.47.62c-.4.41-.65.96-.75,1.62h4.14Zm9.46,4.56h-1.23v-4.37c0-1.63-.59-2.44-1.78-2.44-.61,0-1.12.23-1.53.7-.4.46-.6,1.04-.6,1.74v4.37h-1.23v-7.66h1.23v1.27h.03c.58-.97,1.42-1.45,2.51-1.45.84,0,1.48.27,1.92.82.44.54.67,1.32.67,2.34v4.68Z" />
				<path d="m649.8,584.9h-5.69v-10.73h5.45v1.14h-4.19v3.57h3.88v1.13h-3.88v3.76h4.43v1.14Zm8.28,0h-1.23v-4.37c0-1.63-.59-2.44-1.78-2.44-.61,0-1.12.23-1.53.7-.4.46-.6,1.04-.6,1.74v4.37h-1.23v-7.66h1.23v1.27h.03c.58-.97,1.42-1.45,2.51-1.45.84,0,1.48.27,1.92.82.44.54.67,1.32.67,2.34v4.68Zm5.88-.07c-.29.16-.67.24-1.14.24-1.34,0-2.01-.75-2.01-2.24v-4.53h-1.32v-1.05h1.32v-1.87l1.23-.4v2.27h1.93v1.05h-1.93v4.32c0,.51.09.88.26,1.1.17.22.46.33.87.33.31,0,.58-.08.8-.25v1.05Zm5.65-6.34c-.21-.16-.52-.25-.93-.25-.52,0-.96.25-1.32.74-.35.49-.52,1.17-.52,2.02v3.91h-1.23v-7.66h1.23v1.58h.03c.17-.54.44-.96.8-1.26.36-.3.76-.46,1.2-.46.32,0,.56.03.73.1v1.27Zm7.45-1.24l-3.52,8.89c-.63,1.59-1.51,2.38-2.65,2.38-.32,0-.59-.03-.8-.1v-1.1c.26.09.51.13.73.13.62,0,1.08-.37,1.39-1.11l.61-1.45-2.99-7.65h1.36l2.07,5.9c.02.07.08.27.16.58h.04c.03-.12.07-.31.15-.57l2.18-5.91h1.27Z" />
				<path d="m659.12,407.38v-10.73h3.05c.93,0,1.66.23,2.21.68.54.45.82,1.04.82,1.77,0,.61-.16,1.14-.49,1.59-.33.45-.78.77-1.36.96v.03c.72.08,1.3.36,1.74.82.43.46.65,1.06.65,1.8,0,.92-.33,1.66-.99,2.23-.66.57-1.49.85-2.49.85h-3.13Zm1.26-9.59v3.46h1.29c.69,0,1.23-.16,1.62-.49.39-.33.59-.8.59-1.41,0-1.04-.69-1.56-2.06-1.56h-1.44Zm0,4.59v3.86h1.71c.74,0,1.31-.17,1.71-.52.41-.35.61-.83.61-1.44,0-1.27-.86-1.9-2.59-1.9h-1.44Zm12.84,5h-1.23v-1.2h-.03c-.53.92-1.32,1.38-2.36,1.38-.76,0-1.36-.2-1.8-.61-.43-.4-.64-.94-.64-1.61,0-1.43.84-2.26,2.53-2.5l2.3-.32c0-1.3-.53-1.95-1.58-1.95-.92,0-1.76.31-2.5.94v-1.26c.75-.48,1.62-.72,2.6-.72,1.8,0,2.7.95,2.7,2.86v4.98Zm-1.23-3.88l-1.85.25c-.57.08-1,.22-1.29.43-.29.2-.43.56-.43,1.07,0,.37.13.68.4.92.27.23.63.35,1.07.35.61,0,1.11-.21,1.5-.64.4-.43.6-.97.6-1.62v-.76Zm7.1,3.8c-.29.16-.67.24-1.14.24-1.34,0-2.01-.75-2.01-2.24v-4.53h-1.32v-1.05h1.32v-1.87l1.23-.4v2.27h1.93v1.05h-1.93v4.32c0,.51.09.88.26,1.1.17.22.46.33.87.33.31,0,.58-.08.8-.25v1.05Zm8,.07h-1.23v-4.41c0-1.6-.59-2.39-1.78-2.39-.6,0-1.1.23-1.51.7-.41.46-.61,1.05-.61,1.77v4.34h-1.23v-11.34h1.23v4.95h.03c.59-.97,1.43-1.45,2.51-1.45,1.73,0,2.59,1.04,2.59,3.12v4.72Z" />
				<path d="m81.82,487.3v4.05h-1.26v-10.73h2.95c1.15,0,2.03.28,2.66.84.63.56.95,1.35.95,2.36s-.35,1.85-1.05,2.5c-.7.65-1.64.97-2.84.97h-1.41Zm0-5.54v4.4h1.32c.87,0,1.53-.2,1.98-.59.46-.4.69-.96.69-1.68,0-1.42-.84-2.12-2.51-2.12h-1.47Zm12.54,9.59h-1.23v-1.2h-.03c-.53.92-1.32,1.38-2.36,1.38-.76,0-1.36-.2-1.8-.61-.43-.4-.64-.94-.64-1.61,0-1.43.84-2.26,2.53-2.5l2.3-.32c0-1.3-.53-1.95-1.58-1.95-.92,0-1.76.31-2.5.94v-1.26c.75-.48,1.62-.72,2.6-.72,1.8,0,2.7.95,2.7,2.86v4.98Zm-1.23-3.88l-1.85.25c-.57.08-1,.22-1.29.43-.29.2-.43.56-.43,1.07,0,.37.13.68.4.92.27.23.63.35,1.07.35.61,0,1.11-.21,1.5-.64.4-.43.6-.97.6-1.62v-.76Zm6.99,3.8c-.29.16-.67.24-1.14.24-1.34,0-2.01-.75-2.01-2.24v-4.53h-1.32v-1.05h1.32v-1.87l1.23-.4v2.27h1.93v1.05h-1.93v4.32c0,.51.09.88.26,1.1.17.22.46.33.87.33.31,0,.58-.08.8-.25v1.05Zm2.16-9.53c-.22,0-.41-.07-.56-.22-.15-.15-.23-.34-.23-.57s.08-.42.23-.57c.15-.15.34-.23.56-.23s.41.08.57.23c.16.15.24.34.24.57s-.08.41-.24.56c-.15.15-.34.23-.57.23Zm.6,9.61h-1.23v-7.66h1.23v7.66Zm5.57.18c-1.13,0-2.04-.36-2.72-1.07-.67-.72-1.01-1.67-1.01-2.85,0-1.29.35-2.29,1.05-3.02.7-.72,1.65-1.08,2.85-1.08s2.03.35,2.67,1.05c.64.7.97,1.68.97,2.93s-.35,2.2-1.04,2.94c-.69.73-1.61,1.1-2.78,1.1Zm.09-6.99c-.79,0-1.41.27-1.87.81-.46.53-.69,1.27-.69,2.21s.23,1.62.7,2.15c.46.52,1.08.79,1.86.79s1.4-.26,1.83-.77c.43-.51.64-1.24.64-2.19s-.21-1.7-.64-2.21c-.42-.52-1.03-.78-1.83-.78h0Z" />
				<polygon points="118.96 480.63 113.81 493.14 112.67 493.14 117.8 480.63 118.96 480.63" />
				<path d="m74.18,511.79v-10.73h3.05c.93,0,1.66.23,2.21.68.54.45.82,1.04.82,1.77,0,.61-.16,1.14-.49,1.59-.33.45-.78.77-1.36.96v.03c.72.08,1.3.36,1.74.82.43.46.65,1.06.65,1.8,0,.92-.33,1.66-.99,2.23-.66.57-1.49.85-2.49.85h-3.13Zm1.26-9.59v3.46h1.29c.69,0,1.23-.16,1.62-.49.39-.33.59-.8.59-1.41,0-1.04-.69-1.56-2.06-1.56h-1.44Zm0,4.59v3.86h1.71c.74,0,1.31-.17,1.71-.52.41-.35.61-.83.61-1.44,0-1.27-.86-1.9-2.59-1.9h-1.44Zm12.84,5h-1.23v-1.2h-.03c-.53.92-1.32,1.38-2.36,1.38-.76,0-1.36-.2-1.8-.61-.43-.4-.64-.94-.64-1.61,0-1.43.84-2.26,2.53-2.5l2.3-.32c0-1.3-.53-1.95-1.58-1.95-.92,0-1.76.31-2.5.94v-1.26c.75-.48,1.62-.72,2.6-.72,1.8,0,2.7.95,2.7,2.86v4.98Zm-1.23-3.88l-1.85.25c-.57.08-1,.22-1.29.43-.29.2-.43.56-.43,1.07,0,.37.13.68.4.92.27.23.63.35,1.07.35.61,0,1.11-.21,1.5-.64.4-.43.6-.97.6-1.62v-.76Zm4.77,3.88h-1.23v-11.34h1.23v11.34Zm7.7-.35c-.59.35-1.29.53-2.09.53-1.09,0-1.98-.35-2.65-1.06-.67-.71-1-1.64-1-2.77,0-1.26.36-2.27,1.08-3.04.72-.77,1.69-1.15,2.9-1.15.67,0,1.27.12,1.78.37v1.26c-.57-.4-1.18-.6-1.83-.6-.78,0-1.43.28-1.93.85-.5.56-.75,1.29-.75,2.21s.23,1.61.7,2.12c.47.52,1.11.78,1.9.78.67,0,1.3-.22,1.89-.67v1.17Zm5.06.53c-1.13,0-2.04-.36-2.72-1.07-.67-.72-1.01-1.67-1.01-2.85,0-1.29.35-2.29,1.05-3.02.7-.72,1.65-1.08,2.85-1.08s2.03.35,2.67,1.05c.64.7.97,1.68.97,2.93s-.35,2.2-1.04,2.94c-.69.73-1.61,1.1-2.78,1.1Zm.09-6.99c-.79,0-1.41.27-1.87.81-.46.53-.69,1.27-.69,2.21s.23,1.62.7,2.15c.46.52,1.08.79,1.86.79s1.4-.26,1.83-.77c.43-.51.64-1.24.64-2.19s-.21-1.7-.64-2.21c-.42-.52-1.03-.78-1.83-.78h0Zm12.04,6.81h-1.23v-4.37c0-1.63-.59-2.44-1.78-2.44-.61,0-1.12.23-1.53.7-.4.46-.6,1.04-.6,1.74v4.37h-1.23v-7.66h1.23v1.27h.03c.58-.97,1.42-1.45,2.51-1.45.84,0,1.48.27,1.92.82.44.54.67,1.32.67,2.34v4.68Zm8.41-7.66l-3.52,8.89c-.63,1.59-1.51,2.38-2.65,2.38-.32,0-.59-.03-.8-.1v-1.1c.26.09.51.13.73.13.62,0,1.08-.37,1.39-1.11l.61-1.45-2.99-7.65h1.36l2.07,5.9c.02.07.08.27.16.58h.04c.02-.12.07-.31.15-.57l2.18-5.91h1.27Z" />
				<path d="m449.73,527.13l-1.93,6.83h-.94l-1.4-4.99c-.06-.21-.1-.44-.11-.69h-.02c-.02.23-.06.46-.12.69l-1.41,5h-.93l-2-6.83h.88l1.45,5.24c.06.22.1.45.11.69h.02c.02-.17.07-.4.15-.69l1.51-5.24h.77l1.45,5.27c.05.18.09.39.11.64h.02c.01-.17.06-.38.13-.66l1.39-5.26h.87Z" />
				<polygon points="453.72 527.13 450.44 535.08 449.71 535.08 452.98 527.13 453.72 527.13" />
				<path d="m454.51,533.95v-6.83h1.89c2.41,0,3.61,1.11,3.61,3.33,0,1.05-.33,1.9-1,2.54-.67.64-1.56.96-2.68.96h-1.81Zm.8-6.1v5.38h1.02c.89,0,1.59-.24,2.09-.72.5-.48.75-1.16.75-2.04,0-1.75-.93-2.62-2.79-2.62h-1.07Z" />
			</g>
		</g>
	)
}

export default PlanMM
